<template>
  <div>
    <div class="row mb-3">
      <div class="col-lg-2">
        <button class="btn-blue w-100" @click.prevent="onResetAddModal()">
          Add Schedule
        </button>
      </div>
      <div class="col-lg-2">
        <div v-if="isScheduleAdded">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <div class="add-datepicker">
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="movieSelected.ss_start_date"
                  name="showstartdate"
                  id="showstartdate"
                  typeable
                  v-validate="'required'"
                ></Datepicker>
                <!-- :disabledDates="{
                        to: new Date(Date.now() - 8640000)
                }"-->
                <label
                  :class="
                    typeof movieSelected.ss_start_date === 'object'
                      ? 'active'
                      : ''
                  "
                  style="background: #e9ecef"
                  >Start Date</label
                >
              </div>
            </div>
            <!-- <Tooltip :title="$t('tooltip')" />-->
          </div>
          <p
            v-if="submitted && errors.has('showstartdate')"
            class="error_message"
          >
            {{ errors.first("showstartdate") }}
          </p>
        </div>
      </div>
      <div class="col-lg-2">
        <div v-if="isScheduleAdded">
          <div>
            <div class="input-material">
              <div class="add-datepicker">
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="movieSelected.ss_end_date"
                  name="showenddate"
                  typeable
                  id="showenddate"
                  v-validate="'required'"
                ></Datepicker>
                <!-- :disabledDates="{ to: new Date(Date.now() - 8640000)}" -->
                <label
                  :class="
                    typeof movieSelected.ss_start_date === 'object'
                      ? 'active'
                      : ''
                  "
                  style="background: #e9ecef"
                  >End Date</label
                >
              </div>
            </div>
            <!-- <Tooltip :title="$t('tooltip')" />-->
          </div>
          <p
            v-if="submitted && errors.has('showenddate')"
            class="error_message"
          >
            {{ errors.first("showenddate") }}
          </p>
        </div>
      </div>
      <div class="col-lg-2">
        <button
          v-if="isMovieSelected"
          :disabled="btenable"
          v-on:click="submitSchedule(16)"
          class="btn-blue w-100"
        >
          Save Schedule
        </button>

        <div class="col-lg-6 col-xl-8">
          <div class="row">
            <!-- <div class="col-4">
            <div class="input-material">
              <div class="add-datepicker">
                <Datepicker :monday-first="true"
                  ref="programaticOpen"
                  v-model="scheduleObject.sch_start_date"
                  name="uniquename"
                  @selected="doSomethingInParentComponentFunction"
                ></Datepicker>
                <label
                  :class="scheduleObject.sch_start_date && typeof(scheduleObject.sch_start_date) === 'object' ? 'active': ''"
                >From Date</label>
              </div>
            </div>
            </div>-->
            <!-- <div class="col-4">
            <div class="input-material">
              <div class="add-datepicker">
                <Datepicker :monday-first="true"
                  ref="programaticOpen"
                  v-model="scheduleObject.sch_end_date"
                  name="uniquename"
                  @selected="doSomethingInParentComponentFunction"
                ></Datepicker>
                <label
                  :class="scheduleObject.sch_end_date && typeof(scheduleObject.sch_end_date) === 'object' ? 'active': ''"
                >To Date</label>
              </div>
            </div>
            </div>-->
          </div>
        </div>
      </div>
      <div class="col-lg-3">
        <button
          v-if="isMovieSelected"
          :disabled="btenable"
          v-on:click="submitSchedule(19)"
          class="ml-2 btn-blue w-100"
        >
          Create Planned Schedule
        </button>
      </div>
      <div class="col-lg-6 col-xl-4 d-flex">
        <!-- <button class="btn-transparent">
          <img src="@/assets/img/icons/arrow-left-circle.svg" height="auto" width="35" alt />
        </button>-->
        <!-- <button class="btn-transparent">
          <img src="@/assets/img/icons/arrow-right-circle.svg" height="auto" width="35" alt />
        </button>-->
      </div>
    </div>

    <div v-if="showScheduleCard" class="schedule-wrapper">
      <div class="d-flex w-100">
        <div class="left-nav d-none">
          <div class="sch-header">Movies</div>
          <div class="schedule-movie-list-wrapper">
            <drag
              v-for="(movie, movieIndex) in MoviesList"
              :key="movieIndex"
              :draggable="true"
              class="movie-card"
              :transfer-data="{
                type: 'newMovie',
                movie: movie,
                movieIndex: movieIndex,
              }"
            >
              <div class="schedule-movie-card">
                <div>{{ movie.movie_title }} - {{ movie.lang_name }}</div>
                <!-- <img src="@/assets/img/temp/movie.jpg" class="img-fluid" /> -->
                <img
                  v-lazy="baseURL + movie.md_thumbnail_url"
                  class="img-fluid"
                />
                <div>{{ movie.mf_name }}</div>
              </div>
            </drag>

            <hr />
          </div>
        </div>

        <div class="right-nav d-flex" @scroll="scrolfun">
          <div class="schedule-screen-list-wrapper">
            <div
              class="schedule-screen-name"
              v-for="(screen, screenIndex) in ScreenList"
              :key="screenIndex"
            >
              <span>{{ screen.screen_name }}</span>

              <!-- <span>Screen&nbsp;{{screenIndex}}</span> -->
            </div>
          </div>

          <div class="screen-time-wrapper" @scroll="scrolfun">
            <div
              class="screen-timing-header"
              :style="'top:' + topValue + 'px;'"
            >
              <div
                class="hour-box-header"
                style="width: 120px"
                v-for="(timeHeader, timeHeaderIndex) in intervalsArray"
                :key="timeHeaderIndex"
              >
                <!-- v-if="timeHeaderIndex > 8" -->
                <strong>
                  {{ timeHeader }}
                  <!-- <span v-if="timeHeaderIndex < 12">AM</span> -->
                  <!-- <span v-else>PM</span> -->
                </strong>

                <div class="minutes-bar"></div>
                <div class="minutes-bar"></div>
                <div class="minutes-bar h-100"></div>
                <div class="minutes-bar"></div>
                <div class="minutes-bar"></div>
                <div class="minutes-bar border-0"></div>
              </div>
            </div>

            <div
              class="schedule-screen-row"
              v-for="(screen, screenIndex) in ScreenList"
              :key="screenIndex"
            >
              <drag
                v-for="(
                  screenMovie, screenMovieIndex
                ) in selectedMoviesInScreens[screenIndex].movies"
                :key="'index' + screenIndex + screenMovieIndex"
                class="movie-horizontal-card"
                :transfer-data="{ type: 'presentMovie', movie: screenMovie }"
                @dragstart="startDrag(screenIndex, screenMovieIndex)"
                v-bind:style="{
                  'min-width': screenMovie.length / 1.5 + 'px',
                  left: screenMovie.start / 1.5 + 'px',
                  'z-index': 10,
                  overflow: 'hidden',
                }"
              >
                <!-- style="top: 15px; left: 60px;z-index:10"> -->
                <div class="schedule-card bg-green" style="height: 98px">
                  <div class="schedule-content">
                    <div>
                      <strong>{{ screenMovie.movie_title }}</strong>
                      <small class="d-block">
                        <span>{{ screenMovie.mf_name }}</span>
                        {{ screenMovie.lang_name }}
                        <span>{{ screenMovie.sound_format_name || "-" }}</span>
                      </small>
                    </div>
                    <!-- <img src="@/assets/img/temp/movie.jpg" /> -->
                    <img
                      v-if="false"
                      v-lazy="baseURL + screenMovie.md_thumbnail_url"
                      class="img-fluid"
                    />
                  </div>
                  <div class="schedule-navigations">
                    <button
                      class="btn-schedule-edit"
                      v-on:click="
                        onClickEditMovie(screenMovie, screenMovieIndex, screen)
                      "
                    >
                      Edit
                    </button>

                    <button
                      class="btn-schedule-add"
                      v-on:click="
                        onOpenAddPriceModal(
                          screen,
                          screenMovie,
                          screenIndex,
                          screenMovieIndex
                        )
                      "
                    >
                      Update Price
                    </button>
                    <button
                      v-on:click="
                        onDeleteMovie(
                          screen,
                          screenMovie,
                          screenIndex,
                          screenMovieIndex
                        )
                      "
                      class="btn-schedule-delete"
                    >
                      <img
                        src="@/assets/img/icons/delete-red.svg"
                        height="15"
                        width="15"
                        alt
                      />
                    </button>
                  </div>
                </div>
              </drag>
              <div
                class="hour-box"
                style="width: 120px"
                v-for="(hourofDay, hourofDayIndex) in intervalsArray"
                :key="hourofDayIndex"
              >
                <drop
                  class="minutes-bar drop"
                  v-for="(minutes, minutesIndex) in 6"
                  :key="'index' + screenIndex + minutesIndex"
                  @drop="handleDrop"
                  @dragenter="dragEnter(screenIndex, hourofDay, minutes)"
                ></drop>
              </div>
            </div>

            <!-- <div class="schedule-screen-row" v-for="(loop , screenKey) in 1" :key="screenKey">
              <div class="hour-box" v-for="(time , timingKey) in 10" :key="timingKey">
                <div
                  class="minutes-bar drop"
                  v-for="(minutesBar, minutesBarKey) in 6"
                  :key="minutesBarKey"
                ></div>
              </div>
            </div>-->
          </div>
        </div>
      </div>
    </div>

    <!-- UPDATE MOVIE MODAL -->
    <b-modal
      id="updateMovie"
      ref="updateMovie"
      title="Update Movie"
      hide-footer
      show
    >
      <div>
        <div class="row mx-0">
          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Movie Name:</div>
              <div class="col-8">
                <strong>{{ movieSelected.movie_title }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row hh">
              <div class="col-4">Language:</div>
              <div class="col-8">
                <strong>{{ movieSelected.lang_name }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Format:</div>
              <div class="col-8">
                <strong>{{ movieSelected.mf_name }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Sound Format:</div>
              <div class="col-8">
                <strong>{{ movieSelected.sound_format_name || "-" }}</strong>
              </div>
            </div>
          </div>

          <!-- <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Language:</div>
              <div class="col-8">
                <strong>English</strong>
              </div>
            </div>
          </div>-->

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Run Time</div>
              <div class="col-8">
                <strong>{{ convertToHrs(movieSelected.lengthMinutes) }}</strong>
              </div>
            </div>
          </div>
          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Start Time</div>
              <div class="col-8">
                <!-- <input
                  type="text"
                  v-on:change="onChangeTime($event)"
                  class="input-theme"
                  :value="movieSelected.start_time"
                />-->
                <div class="custom-timepicker">
                  <vue-timepicker
                    manual-input
                    v-model="movieSelected.startTime2"
                    id="showtime"
                    name="showtime"
                    format="HH:mm"
                    class="time_picker"
                    input-width="100%"
                    auto-scroll
                    lazy
                    v-validate="'required'"
                    @change="onEditStartTime($event)"
                  ></vue-timepicker>
                  <!-- <date-picker
                    :value="movieSelected.selected_time"
                    @change="onEditStartTime($event)"
                    lang="en"
                    type="time"
                    format="hh:mm a"
                    :minute-step="1"
                    class="time_picker"
                    placeholder="Show Time"
                    typeable
                    name="showtime"
                    id="showtime"
                    v-validate="'required'"
                  ></date-picker> -->

                  <!-- v-model="selectedMoviesInScreens[selectedScreenIndex].movies[selectedMovieIndex].ss_start_show_time" -->
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">End Time</div>
              <div class="col-8">
                <strong>{{ movieSelected.end_time }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Interval Time</div>
              <div class="col-6">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="movieSelected.interval_time_in_mins"
                      type="text"
                      name="intervaltime"
                      id="intervaltime"
                      v-validate="'required|numeric'"
                    />
                  </div>
                </div>
              </div>
              <div class="col-2">
                <strong>Mins</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Cleaning Time</div>
              <div class="col-6">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="movieSelected.cleaning_time_in_mins"
                      type="text"
                      name="cleaning_time_in_mins"
                      id="cleaning_time_in_mins"
                      v-validate="'required|numeric'"
                    />
                  </div>
                </div>
              </div>
              <div class="col-2">
                <strong>Mins</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Advertisement Time</div>
              <div class="col-6">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="movieSelected.ads_time_in_mins"
                      type="text"
                      name="settingadstime"
                      id="settingadstime"
                      v-validate="'required|numeric'"
                    />
                  </div>
                </div>
              </div>
              <div class="col-2">
                <strong>Mins</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-3">
            <div class="row">
              <div class="col-4">Artwork Image</div>
              <div class="col-6">
                <div class="d-flex align-items-center">
                  <label
                    class="material-file-upload"
                    @click.prevent.stop="setModalData()"
                  >
                    <div
                      class="label"
                      v-bind:class="{
                        'shift-up': movieSelected.sch_artwork_url,
                      }"
                    >
                      {{ "Artwork Image" }}
                    </div>
                    <div class="uploaded-file-name">
                      <div class="text-truncate pt-2">
                        {{ movieSelected.sch_artwork_url }}
                      </div>
                    </div>
                  </label>
                  <Tooltip :title="`Special Schedule Artwork`" />
                </div>
              </div>
              <div class="col-2 align-self-center pl-3">
                <img
                  width="40"
                  height="40"
                  class="rounded c-pointer img-preview"
                  @click="openImageModal()"
                  :src="_GetImagePath(movieSelected.sch_artwork_url)"
                  v-if="movieSelected.sch_artwork_url"
                />
                <img
                  v-else
                  width="35"
                  height="35"
                  class="rounded"
                  alt="Empty Image"
                  src="@/assets/img/icons/empty-image.svg"
                />
              </div>
            </div>
          </div>

          <div class="col-12 pt-3 text-center">
            <button v-on:click="onUpdate('RemoveOldMovie')" class="btn-blue">
              Update
            </button>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- SAVE MOVIE MODAL -->
    <b-modal
      id="saveMovie"
      ref="ratecardmodal"
      title="Update Price"
      hide-footer
      show
    >
      <div>
        <div class="row mx-0">
          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Movie Name:</div>
              <div class="col-8">
                <strong>{{ movieSelected.movie_title }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row hh">
              <div class="col-4">Language:</div>
              <div class="col-8">
                <strong>{{ movieSelected.lang_name }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Format:</div>
              <div class="col-8">
                <strong>{{ movieSelected.mf_name }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Sound Format:</div>
              <div class="col-8">
                <strong>{{ movieSelected.sound_format_name || "-" }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Showtime:</div>
              <div class="col-8">
                <strong>{{ movieSelected.start_time }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Runtime:</div>
              <div class="col-8">
                <strong>{{ convertToHrs(movieSelected.lengthMinutes) }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">End Time:</div>
              <div class="col-8">
                <strong>{{ movieSelected.end_time }}</strong>
              </div>
            </div>
          </div>

          <div
            v-for="(SeatTypes, SeatTypesIndex) in selectedScreenSeatTypes"
            :key="SeatTypesIndex"
            class="col-12 border-bottom py-2"
          >
            <div class="row">
              <div class="col-4 align-self-center">
                {{ SeatTypes.sst_seat_type }}
              </div>
              <div class="col-8">
                <!-- <select
                  v-model="rateCard[selectedScreenIndex.toString() + selectedMovieIndex.toString()][SeatTypesIndex].rate_card_id"
                  v-on:change="onChangeRateCard($event,SeatTypes,SeatTypesIndex)"
                  class="select-ratecard"
                >
                  <option value>Select Rate Card</option>
                  <option
                    v-for="(Ratecard, RatecardIndex) in  RatecardsList"
                    :key="RatecardIndex"
                    :value="Ratecard.rc_id"
                  >{{ Ratecard.rate_card_name }}</option>
                </select>-->
                <!-- {{selectedMoviesInScreens[selectedScreenIndex].movies[selectedMovieIndex].scheduleShowPrice[SeatTypesIndex]}} -->
                <!-- {{selectedMoviesInScreens[selectedScreenIndex].movies[selectedMovieIndex].scheduleShowPrice[SeatTypesIndex]}} -->

                <b-dropdown
                  class="w-100"
                  variant="dropdown-curve"
                  :text="
                    movieSelected.scheduleShowPrice[SeatTypesIndex]
                      .rate_card_name
                  "
                >
                  <div class="px-2 pb-2">
                    <input
                      required
                      autofocus
                      type="search"
                      placeholder="Search Rate Card"
                      class="form-control form-control-sm"
                      v-on:keyup="onSearchRateCard($event, SeatTypesIndex)"
                      v-on:keydown="onSearchRateCard($event, SeatTypesIndex)"
                      v-model="
                        movieSelected.scheduleShowPrice[SeatTypesIndex]
                          .searchRateCard
                      "
                    />
                  </div>
                  <b-dropdown-item
                    v-for="(Ratecard, RatecardIndex) in RatecardsList"
                    :key="RatecardIndex"
                    v-on:click="
                      onChangeRateCard(Ratecard, SeatTypes, SeatTypesIndex)
                    "
                    >{{ Ratecard.rc_g_name }}</b-dropdown-item
                  >
                </b-dropdown>
                <p
                  v-if="
                    submitted &&
                    movieSelected.scheduleShowPrice[SeatTypesIndex]
                      .rate_card_name == 'Select Rate Card'
                  "
                  class="error_message"
                >
                  {{ msgratecard }}
                </p>
              </div>
            </div>
          </div>
          <!-- <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Silver</div>
              <div class="col-8 d-flex align-items-center justify-content-between">
                <select class="select-ratecard">
                  <option disabled value>Select Rate Card</option>
                  <option
                    v-for="(Ratecard, RatecardIndex) in  RatecardsList"
                    :key="RatecardIndex"
                    :value="Ratecard.rc_id"
                  >{{ Ratecard.rate_card_name }}</option>
                </select>
              </div>
            </div>
          </div>-->

          <div class="col-12 pt-3 text-center">
            <button v-on:click="onClickupdateRateCard()" class="btn-blue">
              Update
            </button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      hide-footer
      hide-header
      size="lg"
      id="modal-1"
      ref="test"
      no-close-on-backdrop
    >
      <div
        style="
          padding: 1rem;
          border-bottom: 1px solid #dee2e6;
          font-size: 20px;
          font-weight: bold;
          margin: 0 -15px;
        "
      >
        Add Schedule
      </div>
      <div class="pt-3">
        <button
          class="btn-modal-close"
          style="top: 15px; right: 15px; position: absolute; z-index: 99"
          @click="closeAddScheduleModal()"
        >
          &times;
        </button>
        <div class="row mx-0">
          <div class="col-md-6 mb-4">
            <label>{{ $tc("cinema", 2) }}</label>
            <div>
              <b-dropdown
                :disabled="isRoleID || isScheduleAdded"
                :text="selected.cinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Cinema"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema($event.target.value)"
                    v-on:keydown="onSearchCinema($event.target.value)"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(Cinema, CinemaIndex) in CinemasList"
                  :key="CinemaIndex"
                  v-on:click="onSelectCinema($event, Cinema)"
                  >{{ Cinema.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
              <p
                v-if="submitted && selected.cinema == 'Select Cinema'"
                class="error_msg"
              >
                {{ msgcinema }}
              </p>
            </div>
          </div>

          <div class="col-md-6 mb-4">
            <div class>
              <label>{{ $t("Screens") }}</label>
            </div>
            <div class>
              <b-dropdown
                :text="selected.screen_name"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Screen Name"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchScreen($event.target.value)"
                    v-on:keydown="onSearchScreen($event.target.value)"
                    v-model="searchScreen"
                  />
                </div>
                <b-dropdown-item
                  v-for="(Screen, ScreenIndex) in ScreenList"
                  @click="onSelectScreen($event, Screen, ScreenIndex)"
                  :key="ScreenIndex"
                  ><span :style="Screen.totalSeatLayout == 0 ? 'color:red' : ''"
                    >{{ Screen.screen_name }}
                    {{
                      Screen.totalSeatLayout == 0 ? " (No Seat Layout) " : ""
                    }}</span
                  ></b-dropdown-item
                >
              </b-dropdown>
              <p
                v-if="submitted && selected.screen_name == 'Select Screen'"
                class="error_message"
              >
                {{ msgscreen }}
              </p>
              <p v-if="videoFormatError" class="error_message">
                {{ $t("videoFormatError") }}
              </p>
              <p v-if="soundFormatError" class="error_message">
                {{ $t("soundFormatError") }}
              </p>
            </div>
          </div>

          <div class="col-md-6 mb-4">
            <div class>
              <label>{{ $tc("movie", 1) }}</label>
            </div>
            <div class>
              <div class="dropdown-curve-container">
                <multiselect
                  v-model="selectedMovie"
                  id="ajax"
                  label="movie_name"
                  track-by="md_id"
                  :placeholder="selected_movie"
                  open-direction="bottom"
                  :options="MoviesList"
                  :multiple="false"
                  :searchable="true"
                  :loading="isSearchLoading"
                  :internal-search="false"
                  :clear-on-select="false"
                  :close-on-select="true"
                  :options-limit="300"
                  :max-height="600"
                  :show-no-results="true"
                  :hide-selected="true"
                  @select="onSelectMovie"
                  @search-change="onAsyncSearchMovies"
                  select-label="Select"
                  deselect-label="Remove"
                >
                  <span slot="noResult">Oops! No Results found.</span>
                  <template slot="option" slot-scope="props"
                    ><span
                      :class="`${
                        !props.option.mrrdr_runtime ||
                        props.option.mrrdr_runtime == 0
                          ? 'ssmv-red-color'
                          : ''
                      }`"
                      >{{ props.option.movie_name }}</span
                    >
                  </template>
                </multiselect>
              </div>
              <p
                v-if="submitted && selectedMovie.length == 0"
                class="error_message"
              >
                {{ msgmovie }}
              </p>
              <p v-if="licenseDateError" class="warning_message">
                {{ $t("licenseDateError") }}
              </p>
            </div>
          </div>

          <div class="col-md-6 mb-4">
            <div class>
              <!-- $t("intervaltime") -->
              <label>{{ $t("intermissiontime") }} ( {{ $t("inmins") }} )</label>
            </div>
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  placeholder="."
                  v-model="selectedCinemaSettings.interval_time_in_mins"
                  type="text"
                  name="intervaltime"
                  id="intervaltime1"
                  v-validate="'required|numeric'"
                />
              </div>
            </div>
            <p
              v-if="submitted && errors.has('intervaltime')"
              class="error_message"
            >
              {{ errors.first("intervaltime") }}
            </p>
          </div>

          <div class="col-md-6 mb-4">
            <div class>
              <label>{{ $t("cleaningtime") }} ( {{ $t("inmins") }} )</label>
            </div>
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  placeholder="."
                  v-model="selectedCinemaSettings.cleaning_time_in_mins"
                  type="text"
                  name="cleaningtime"
                  id="cleaningtime1"
                  v-validate="'required|numeric'"
                />
              </div>
            </div>
            <p
              v-if="submitted && errors.has('cleaningtime')"
              class="error_message"
            >
              {{ errors.first("cleaningtime") }}
            </p>
          </div>

          <div class="col-md-6 mb-4">
            <div class>
              <label
                >{{ $t("advertisementtime") }} ( {{ $t("inmins") }} )</label
              >
            </div>
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  placeholder="."
                  v-model="selectedCinemaSettings.ads_time_in_mins"
                  type="text"
                  name="settingadstime"
                  id="settingadstime1"
                  v-validate="'required|numeric'"
                />
              </div>
            </div>
            <p
              v-if="submitted && errors.has('settingadstime')"
              class="error_message"
            >
              {{ errors.first("settingadstime") }}
            </p>
          </div>

          <div class="col-md-6 mb-4">
            <div class>
              <label>{{ $tc("startdate", 1) }}</label>
            </div>
            <div class="d-flex align-items-center">
              <div class="input-material">
                <div class="add-datepicker">
                  <button
                    class="btn-clearDate"
                    v-if="
                      movieSelected.ss_start_date && isScheduleAdded === false
                    "
                    v-on:click="clear_ss_start_date()"
                  >
                    ✖
                  </button>
                  <Datepicker
                    :monday-first="true"
                    :disabled="isScheduleAdded"
                    ref="programaticOpen"
                    v-model="movieSelected.ss_start_date"
                    name="showstartdate"
                    id="showstartdate"
                    typeable
                    v-validate="'required'"
                    :disabled-dates="disabledDates"
                  ></Datepicker>
                  <!-- :disabledDates="{
                        to: new Date(Date.now() - 8640000)
                  }"-->
                  <label
                    :class="
                      typeof movieSelected.ss_start_date === 'object'
                        ? 'active'
                        : ''
                    "
                    >Show Start Date</label
                  >
                </div>
              </div>
              <!-- <Tooltip :title="$t('tooltip')" />-->
            </div>
            <p
              v-if="submitted && errors.has('showstartdate')"
              class="error_message"
            >
              {{ errors.first("showstartdate") }}
            </p>
          </div>

          <div class="col-md-6 mb-4">
            <div class>
              <label>{{ $tc("enddate", 1) }}</label>
            </div>
            <div class="d-flex align-items-center">
              <div class="input-material">
                <div class="add-datepicker">
                  <button
                    class="btn-clearDate"
                    v-if="
                      movieSelected.ss_end_date && isScheduleAdded === false
                    "
                    v-on:click="clear_ss_end_date()"
                  >
                    ✖
                  </button>
                  <Datepicker
                    :monday-first="true"
                    :disabled="isScheduleAdded"
                    ref="programaticOpen"
                    v-model="movieSelected.ss_end_date"
                    name="showenddate"
                    id="showenddate"
                    typeable
                    v-validate="'required'"
                    :disabledDates="{ to: movieSelected.ss_start_date }"
                  ></Datepicker>
                  <label
                    :class="
                      typeof movieSelected.ss_end_date === 'object'
                        ? 'active'
                        : ''
                    "
                    >Show End Date</label
                  >
                </div>
              </div>
              <!-- <Tooltip :title="$t('tooltip')" />-->
            </div>
            <p
              v-if="submitted && errors.has('showenddate')"
              class="error_message"
            >
              {{ errors.first("showenddate") }}
            </p>
          </div>

          <div class="col-md-6 mb-4">
            <div class>
              <label>{{ $tc("showtime", 1) }}</label>
            </div>
            <div class>
              <div class="custom-timepicker">
                <vue-timepicker
                  manual-input
                  v-model="movieSelected.startTime2"
                  id="showtime"
                  name="showtime"
                  format="HH:mm"
                  class="time_picker"
                  input-width="100%"
                  auto-scroll
                  lazy
                  @change="onChangeShowStartTime($event)"
                  v-validate="'required'"
                ></vue-timepicker>
                <!-- <date-picker
                  v-model="movieSelected.start_time"
                  @change="onChangeShowStartTime($event)"
                  lang="en"
                  type="time"
                  typeable
                  :disabled-time="true"
                  format="hh:mm a"
                  :minute-step="1"
                  class="time_picker"
                  placeholder="Show Time"
                  name="showtime"
                  id="showtime"
                  v-validate="'required'"
                /> -->
                <!-- v-model="selectedMoviesInScreens[selectedScreenIndex].movies[selectedMovieIndex].ss_start_show_time" -->
              </div>
              <p v-if="submitted && errors.has('showtime')" class="error_msg">
                {{ errors.first("showtime") }}
              </p>
            </div>
          </div>

          <div
            class="col-lg-6 mb-5"
            :key="SeatTypesIndex"
            v-for="(SeatTypes, SeatTypesIndex) in selectedScreenSeatTypes"
          >
            <label>{{ SeatTypes.sst_seat_type }}</label>
            <!-- <select
                  v-model="rateCard[selectedScreenIndex.toString() + selectedMovieIndex.toString()][SeatTypesIndex].rate_card_id"
                  v-on:change="onChangeRateCard($event,SeatTypes,SeatTypesIndex)"
                  class="select-ratecard"
                >
                  <option value>Select Rate Card</option>
                  <option
                    v-for="(Ratecard, RatecardIndex) in  RatecardsList"
                    :key="RatecardIndex"
                    :value="Ratecard.rc_id"
                  >{{ Ratecard.rate_card_name }}</option>
            </select>-->
            <!-- {{selectedMoviesInScreens[selectedScreenIndex].movies[selectedMovieIndex].scheduleShowPrice[SeatTypesIndex]}} -->
            <!-- {{selectedMoviesInScreens[selectedScreenIndex].movies[selectedMovieIndex].scheduleShowPrice[SeatTypesIndex]}} -->

            <b-dropdown
              class="w-100"
              variant="dropdown-curve"
              :text="
                movieSelected.scheduleShowPrice[SeatTypesIndex].rate_card_name
              "
            >
              <div class="px-2 pb-2">
                <input
                  required
                  autofocus
                  type="search"
                  class="form-control form-control-sm"
                  placeholder="Search Rate Card"
                  v-on:keyup="onSearchRateCard($event, SeatTypesIndex)"
                  v-on:keydown="onSearchRateCard($event, SeatTypesIndex)"
                  v-model="
                    movieSelected.scheduleShowPrice[SeatTypesIndex]
                      .searchRateCard
                  "
                />
              </div>
              <b-dropdown-item
                v-for="(Ratecard, RatecardIndex) in RatecardsList"
                :key="RatecardIndex"
                v-on:click="
                  onChangeRateCard(Ratecard, SeatTypes, SeatTypesIndex)
                "
                >{{ Ratecard.rc_g_name }}</b-dropdown-item
              >
            </b-dropdown>
            <p
              v-if="
                submitted &&
                movieSelected.scheduleShowPrice[SeatTypesIndex]
                  .rate_card_name == 'Select Rate Card'
              "
              class="error_message"
            >
              {{ msgratecard }}
            </p>
          </div>

          <div class="col-md-6 mb-4">
            <label>{{ "Artwork Image" }}</label>
            <div class="row">
              <div class="col-10">
                <div class="d-flex align-items-center">
                  <label
                    class="material-file-upload"
                    @click.prevent.stop="setModalData()"
                  >
                    <div
                      class="label"
                      v-bind:class="{
                        'shift-up': movieSelected.sch_artwork_url,
                      }"
                    >
                      {{ "Artwork Image" }}
                    </div>
                    <div class="uploaded-file-name">
                      <div class="text-truncate pt-2">
                        {{ movieSelected.sch_artwork_url }}
                      </div>
                    </div>
                  </label>
                  <Tooltip :title="`Special Schedule Artwork`" />
                </div>
              </div>
              <div class="col-2 align-self-center pl-3">
                <img
                  width="40"
                  height="40"
                  class="rounded c-pointer img-preview"
                  @click="openImageModal()"
                  :src="_GetImagePath(movieSelected.sch_artwork_url)"
                  v-if="movieSelected.sch_artwork_url"
                />
                <img
                  v-else
                  width="35"
                  height="35"
                  class="rounded"
                  alt="Empty Image"
                  src="@/assets/img/icons/empty-image.svg"
                />
              </div>
            </div>
          </div>

          <div class="col-lg-12 text-center">
            <button
              :disabled="btenable"
              @click.prevent.stop="onUpdate()"
              class="btn-blue"
            >
              {{ $t("submit") }}
            </button>
            <!-- <button @click.prevent.stop="onUpdate()" class="btn-blue">{{ $t('save') }}</button>
              <button @click.prevent.stop="onResetForm" class="btn-black">{{ $t('reset') }}</button>
            <b-button class="btn-outline-grey" variant="default">{{ $t('cancel') }}</b-button>-->
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
      ref="preview-modal"
      id="selected-image-preview-modal"
      size="lg"
      hide-header
      hide-footer
    >
      <label class="h4 mt-2 mb-4 text-center">{{ "Artwork Image" }}</label>
      <button
        class="btn-modal-close"
        @click="$bvModal.hide('selected-image-preview-modal')"
      >
        &times;
      </button>
      <br />
      <div v-if="movieSelected.sch_artwork_url">
        <img
          :src="_GetImagePath(movieSelected.sch_artwork_url)"
          class="img-fluid"
        />
      </div>
      <div v-else class="mx-auto w-100">
        {{ "No Preview Available" }}
      </div>
    </b-modal>
    <ImageGallery
      v-bind:propImageName="'ArtWork Image'"
      v-bind:openModal="showModal"
      v-bind:set_height="NaN"
      v-bind:set_width="NaN"
      :showPercentageLoader="true"
      :img_desc="'Schedule Artwork Image'"
      :resetImgData="false"
      :category="'Movie Poster'"
    ></ImageGallery>
  </div>
</template>

<script>
import momentT from "moment-timezone";

import scheduleService from "@/services/scheduleService";
import CinemasService from "@/services/CinemasService";
import MasterService from "@/services/MasterService";
import moment from "moment";
import { BASEURL } from "@/config/index.js";
import Vue from "vue";
import DatePicker from "vue2-datepicker";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import { mapGetters } from "vuex";
import ImageGallery from "@/components/Pages/ImageGallery/imageGalleryModal";
import _ from "lodash";

export default {
  components: { DatePicker, VueTimepicker, ImageGallery, VueCropper },

  data() {
    return {
      isSearchLoading: false,
      searchValue: "",
      calledBy: null,
      showModal: false,
      filmTitle: "",
      searchCinema: "",
      searchScreen: "",
      btenable: false,
      disabledDates: {
        to: new Date(Date.now() - 8640000),
      },
      presentValue: "",
      oldValue: "",
      timeZone: {
        tz_name: "",
        tz_utc_offset: "",
      },
      isScheduleAdded: false, // this blocks the date selector when the schedule is added for the first time
      movieSelectedTimeCopy: "",
      topValue: 0,
      isRoleID: true, // HO Manager and Super Admin, this is set to false to select any Cinema
      display_time: "",
      intervalsArray: [],
      submitted: false,
      msgcinema: "Please Select Cinema",
      msgscreen: "Please Select Screen",
      msgmovie: "Please Select Movie",
      msgratecard: "Please Select Rate Card",
      // disabledDates: {
      //   to: new Date(2019, 9, 26)
      // },
      selectedMovie: [],
      selected_movie: "Select movie",
      selectedScreen: "Select a screen",
      selectedCinema: "Selected Cinema",
      rateCard: {},
      baseURL: BASEURL,
      movieSelectedIndex: null,
      movieSelected: {
        ss_start_date: "",
        ss_end_date: "",
        lang_name: "",
        md_id: 12,
        md_thumbnail_url: "/uploads/movies/1566220586425-dummy.jpg",
        mf_name: "",
        movie_id: 0,
        movie_is_active: "Y",
        movie_title: "",
        mrrdr_runtime: 0,
        selected_time_copy: "",
        sound_format_name: "",
        interval_time_in_mins: "",
        cleaning_time_in_mins: "",
        ads_time_in_mins: "",
        startTime2: "",
        sch_artwork_url: "",
      },
      movieSelectedCopy: {
        ss_start_date: "",
        ss_end_date: "",
        lang_name: "",
        md_id: 0,
        md_thumbnail_url: "/uploads/movies/1566220586425-dummy.jpg",
        mf_name: "",
        movie_id: 0,
        movie_is_active: "Y",
        movie_title: "",
        mrrdr_runtime: 0,
        selected_time_copy: "",
        sound_format_name: "",
        interval_time_in_mins: "",
        cleaning_time_in_mins: "",
        ads_time_in_mins: "",
        sch_artwork_url: "",
      },
      selectedMovieIndex: null,
      selectedScreenIndex: null,
      //
      lists: {
        movies: [],
        cinemas: {
          list: [],
          selectedCinema: {
            cine_name: "select cinema",
          },
        },
        screens: [],
      },
      selectedNewDate: "",
      initialSelectedScreen: "Screen 2",
      silderOne: {
        infinite: false,
        dots: false,
        arrows: true,
        slidesToShow: 7,
      },
      silderTwo: {
        infinite: false,
        dots: false,
        arrows: true,
        slidesToShow: 5,
      },
      dropLocation: {
        screen: "",
        hour: "",
        minute: "",
      },
      draggedObject: {
        screen: "",
        length: "",
        oldStart: "",
        newStart: "",
        movie: "",
      },
      selectedMoviesInScreens: [],
      selectedCinemaSettings: {
        interval_time_in_mins: null,
        cleaning_time_in_mins: null,
        ads_time_in_mins: null,
      },
      // Saif

      showScheduleCard: false,
      selectedScreenSeatTypes: [],
      screen_seat_card_mapping: [],
      selectedRateCardObject: {},

      CinemasList: [],
      CinemasListCopy: [],
      MoviesList: [],
      ScreenList: [],
      ScreenListCopy: [],
      RatecardsList: [],
      RatecardsListCopy: [],
      CinemasSettings: {
        cine_setting_id: null,
        cine_id: null,
        cine_operation_start_time: null,
        cine_operation_end_time: null,
        cine_cleaning_time_in_mins: null,
        cine_setting_ads_time_in_mins: null,
        cine_interval_time_in_mins: null,
        cine_seat_release_time_in_mins: null,
        cine_cutoff_time_in_mins: null,
        cine_setting_is_active: "Y",
        cine_time_zone: "",
      },
      selected: {
        cinema: "Select Cinema",
        screen_name: "Select Screen",
        cinemaObject: {},
      },
      scheduleObject: {
        cinema_id: null,
        sch_start_date: null,
        sch_end_date: null,
        sch_is_active: "Y",
      },

      FinalScreenAndMovieScheduleList: [
        {
          screen_id: null,

          // sch_start_date: null,
          // sch_end_date: null,
          // sch_is_active: "Y",
          movies: [
            {
              movie_details_id: null,
              movie_title: null,
              ss_start_show_time: null,
              ss_end_show_time: null,
              ss_start_date: null,
              ss_end_date: null,
              ss_start_date_time: null,
              ss_end_date_time: null,
              ss_is_active: "Y",
              scheduleShowPrice: [
                {
                  rate_card_id: null,
                  schedule_show_id: null,
                  screen_seat_type_id: null,
                  p_start_date_time: null,
                  p_end_date_time: null,
                  p_is_active: "Y",
                },
              ],
            },
          ],
        },
      ],
      FinalArray: [],
      // Saif
      videoFormatError: false,
      soundFormatError: false,
      licenseDateError: false,
    };
  },
  computed: {
    ...mapGetters(["finalImagePath"]),
    isMovieSelected() {
      return (
        this.selectedMoviesInScreens.filter((singleScreen) => {
          return singleScreen.movies.length > 0;
        }).length > 0
      );
    },
  },
  beforeMount: function () {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    // this.getAllActiveScreens();
    // this.getAllMovies();
    this.getAllActiveCinemas(obj);
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    if (CinemaObj) {
      this.onSelectCinema(null, CinemaObj);
    }
  },
  watch: {
    "$store.getters.getSelectedDropDownCinema": function (CinemaObj) {
      if (CinemaObj) {
        this.onSelectCinema(null, CinemaObj);
      }
    },
    finalImagePath(newval) {
      console.log("newval", newval);
      this.movieSelected.sch_artwork_url = newval;
      this.$forceUpdate();
    },
  },
  mounted() {
    this.$refs.test.show();
  },
  methods: {
    openImageModal: function () {
      this.$refs["preview-modal"].show();
    },
    setModalData() {
      this.showModal = !this.showModal;
    },
    closeAddScheduleModal: function () {
      this.$refs["test"].hide();
      this.$router.push({
        path: "/cinema-manager/view-schedule",
      });
    },
    onSearchCinema(value) {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.CinemasList = this.CinemasListCopy.filter((x) => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.CinemasList = this.CinemasListCopy;
      }
    },
    onSearchScreen(value) {
      if (this.searchScreen && this.searchScreen.length > 0) {
        this.ScreenList = this.ScreenListCopy.filter((x) => {
          if (
            x.screen_name
              .toLowerCase()
              .includes(this.searchScreen.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.ScreenList = this.ScreenListCopy;
      }
    },
    scrolfun() {
      console.log("scrolling");
      this.topValue = event.srcElement.scrollTop;
    },
    onResetAddModal: function () {
      // (this.selected.cinema = "Please Select Cinema"),
      this.selected.screen_name = "Select Screen";
      this.selectedScreen = {};
      this.selectedScreenIndex = null;
      this.movieSelected.start_time = null;
      this.$refs["test"].show();
      // this.selectedScreenSeatTypes = [];
      // this.selectedMovie = {};
      // console.log("this.selectedMovie :>> ", this.selectedMovie);
      //TODO - if cinema is already selected, make it non editable
      // if(this.isScheduleAdded == true){
      //   this.onSelectCinema(null, this.selected.cinemaObject)
      // }else{
      // this.selected.cinema = "Please Select Cinema";
      // }
      // this.selectedMovie = "Please Select Movie";
      // this.selected.screen_name = "Please Select Screen";
    },
    scrolfun() {
      this.topValue = event.srcElement.scrollTop;
    },
    onclose: function (e) {},
    clear_ss_start_date: function () {
      this.movieSelected.ss_start_date = null;
    },
    clear_ss_end_date: function () {
      this.movieSelected.ss_end_date = null;
    },
    onChangeTimePicker: function (date) {
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes + " " + ampm;
      return strTime;
      // this.movieSelected.start_time = formatAMPM(this.movieSelected.start_time);
    },
    convertToHrs: function (value) {
      let hours = Math.floor(value / 60);
      let minutes = Math.floor(value % 60);
      return hours + "hrs " + minutes + " mins";
    },
    onChangeTime: function (event) {
      console.log("eventaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa  :", event);
      this.movieSelected.start_time = event.target.value;
      this.display_time = moment(event.target.value).format("h:mm A");
      this.movieSelected["selected_time"] = event.target.value;
    },
    onEditStartTime: function (event) {
      // if (this.selectedMoviesInScreens[this.selectedScreenIndex]["movies"]) {
      //   this.movieSelectedCopy = this.selectedMoviesInScreens[
      //     this.selectedScreenIndex
      //   ]["movies"][this.movieSelectedIndex];
      //   this.movieSelectedCopy.selected_time = this.movieSelected.selected_time_copy;
      //   console.log("othis.movieSelectedCopybject :", this.movieSelectedCopy);
      // }

      this.onChangeShowStartTime(event);
    },
    onSearchRateCard: function (event, RatecardIndex) {
      this.movieSelected.scheduleShowPrice[RatecardIndex]["searchRateCard"] =
        event.target.value;
      if (
        this.movieSelected.scheduleShowPrice[RatecardIndex]["searchRateCard"]
          .length > 0
      ) {
        this.RatecardsList = this.RatecardsListCopy.filter((x) => {
          if (
            x.rc_g_name
              .toLowerCase()
              .includes(
                this.movieSelected.scheduleShowPrice[RatecardIndex][
                  "searchRateCard"
                ].toLowerCase()
              )
          )
            return x;
        });
      } else {
        this.RatecardsList = this.RatecardsListCopy;
      }
      this.$forceUpdate();
    },
    onChangeShowStartTime: function (event) {
      console.log("old event test", event);
      console.log(
        "this.movieSelected.start_time",
        this.movieSelected.start_time
      );
      event = new Date(
        moment(event.displayTime, "HH:mm").format("YYYY-MM-DD, HH:mm:ss")
      );
      // event = moment(event.displayTime, 'hh:mm a').format('ddd MMM DD YYYY HH:mm:ss')
      this.movieSelected.selected_time = event;
      this.movieSelected.start_time = event;
      console.log(
        "this.movieSelected.selected_time",
        this.movieSelected.selected_time
      );
      let a = "";
      a = moment(
        moment().format("YYYY-MM-DD") + " " + moment(event).format("HH:mm")
      );
      console.log("a", a);
      let currentTime = moment(
        moment().format("YYYY-MM-DD") + " " + moment().format("HH:mm")
      );
      let start_date = this.movieSelected.ss_start_date;
      let end_date = this.movieSelected.ss_end_date;
      // console.log("start date", this.movieSelected.ss_start_date);
      // console.log("end date", this.movieSelected.ss_end_date);

      if (
        moment(start_date).format("YYYY-MM-DD") ===
          moment().format("YYYY-MM-DD") &&
        a.isBefore(currentTime)
      ) {
        this.$toasted.show("Cannot select past time of today");
        this.movieSelected["selected_time"] = "";
        this.movieSelectedTimeCopy = "";
        this.movieSelected.start_time = "";
        // this.
        this.$forceUpdate();
        return;
      }

      console.log("a :", a);
      if (
        moment(
          moment().format("YYYY-MM-DD") +
            " " +
            this.CinemasSettings.cine_operation_start_time
        ).isAfter(a)
      ) {
        a = moment(
          moment().add(1, "days").format("YYYY-MM-DD") +
            " " +
            moment(event).format("HH:mm")
        );
      }
      console.log("a :", a);
      if (
        moment(
          moment().format("YYYY-MM-DD") +
            " " +
            this.CinemasSettings.cine_operation_end_time
        ).isBefore(
          moment(
            moment().format("YYYY-MM-DD") +
              " " +
              this.CinemasSettings.cine_operation_start_time
          )
        )
      ) {
        if (
          moment(
            moment().add(1, "days").format("YYYY-MM-DD") +
              " " +
              this.CinemasSettings.cine_operation_end_time
          ).isSameOrAfter(a) &&
          moment(
            moment().format("YYYY-MM-DD") +
              " " +
              this.CinemasSettings.cine_operation_start_time
          ).isSameOrBefore(a)
        ) {
          console.log("object :", this.CinemasSettings.cine_operation_end_time);
          console.log("came here 1 aaaaaaaaa :");
          console.log("event :", event);
          this.movieSelected["selected_time"] = event;
          this.movieSelectedTimeCopy = event;
          // this.
          this.$forceUpdate();
        } else {
          this.movieSelected.start_time = "";
          return this.$toasted.show(
            "Cannot select showtime beyond Operation Timings "
          );
        }
      } else if (
        this.CinemasSettings.cine_operation_end_time ==
          this.CinemasSettings.cine_operation_start_time ||
        (moment(
          moment().format("YYYY-MM-DD") +
            " " +
            this.CinemasSettings.cine_operation_end_time
        ).isSameOrAfter(a) &&
          moment(
            moment().format("YYYY-MM-DD") +
              " " +
              this.CinemasSettings.cine_operation_start_time
          ).isSameOrBefore(a))
      ) {
        console.log("came here 2222222 :", event);
        this.movieSelected["selected_time"] = event;
        this.movieSelectedTimeCopy = event;
        // this.
        this.$forceUpdate();
      } else {
        this.movieSelected.start_time = "";
        return this.$toasted.show(
          "Cannot select showtime beyond Operation Timings "
        );
      }

      let selected_show_time = moment(event);
      console.log(
        "selected_show_time",
        selected_show_time.format("YYYY-MM-DD HH:mm")
      );

      for (let [
        seatTypeIndex,
        seatType,
      ] of this.selectedScreenSeatTypes.entries()) {
        console.log(
          "🚀 ~ file: schedule2.vue ~ line 1635 ~ ]ofthis.selectedScreenSeatTypes.entries ~ this.screen_seat_card_mapping",
          this.screen_seat_card_mapping
        );

        let applicableSeatTypes = this.screen_seat_card_mapping.filter(
          (x) => x.screen_seat_type_id == seatType.sst_id
        );
        console.log(
          "🚀 ~ file: schedule2.vue ~ line 1628 ~ ]ofthis.selectedScreenSeatTypes.entries ~ applicableSeatTypes",
          applicableSeatTypes
        );

        for (let screen_seat_type of applicableSeatTypes) {
          let start_date_time = moment(
            screen_seat_type.start_date_time,
            "HH:mm:ss"
          );
          let end_date_time = moment(
            screen_seat_type.end_date_time,
            "HH:mm:ss"
          );

          if (
            selected_show_time.isSameOrAfter(start_date_time) &&
            selected_show_time.isSameOrBefore(end_date_time) &&
            screen_seat_type[
              `is_${selected_show_time.format("dddd").toLowerCase()}`
            ] === "Y"
          ) {
            let foundRateCardId = screen_seat_type.rate_card_id;
            let RateCard = this.RatecardsList.find(
              (rc) => rc.rc_g_id == foundRateCardId
            );

            if (RateCard) {
              console.log(
                "found rate card group for seat type: ",
                seatTypeIndex
              );
              this.onChangeRateCard(RateCard, seatType, seatTypeIndex);
              break;
            }
          }
        }
      }
    },
    onClickEditMovie: function (screenMovie, screenMovieIndex, screen) {
      this.movieSelected = screenMovie;
      this.movieSelectedIndex = screenMovieIndex;
      this.selectedScreenSeatTypes = screen.screen_seat_types;
      this.screen_seat_card_mapping = screen.screen_seat_card_mapping;
      this.$refs["updateMovie"].show();
    },
    convertToTime: function (value, value1) {
      // let totalMinutes = (this.movieSelected.start * 10) / 30;
      // let _totalMinutes = Math.floor(
      //   totalMinutes + this.movieSelected.lengthMinutes
      // );

      // let start = moment(this.movieSelected.selected_time);
      // console.log(
      //   "this.movieSelected.selected_time :",
      //   this.movieSelected.selected_time
      // );
      // console.log(
      //   "this.movieSelected.selected_time, :",
      //   this.movieSelected.selected_time
      // );
      // var start = moment(
      //   this.movieSelected.selected_time,
      //   "YYYY-MM-DD hh:mm a"
      // )
      // console.log("start :", start);
      // var current = moment(start);
      // console.log("current :", current);
      // let end_time = current.add(this.movieSelected.lengthMinutes, "minutes");

      let end_time = moment(this.movieSelected.selected_time)
        .add(parseInt(this.movieSelected.lengthMinutes), "m")
        .toDate();

      // let end_time = start.add(
      //   parseInt(this.movieSelected.lengthMinutes),
      //   "minutes"
      // );
      this.movieSelected.end_time = moment(end_time).format("hh:mm A");
      // console.log("end_time :", end_time);
      // let _hours = Math.floor(_totalMinutes / 60);
      // let _minutes = _totalMinutes % 60;
      // let _ampm = "AM";
      // if (_hours > 12) {
      //   _ampm = "PM";
      //   _hours = _hours - 12;
      // }
      // _minutes = _minutes >= 10 ? _minutes : "0" + _minutes;

      // this.movieSelected.end_time = _hours + ":" + _minutes + " " + _ampm;
      // let hours = Math.floor(totalMinutes / 60);
      // let minutes = Math.floor(totalMinutes % 60);
      // let ampm = "AM";
      // if (hours > 12) {
      //   ampm = "PM";
      //   hours = hours - 12;
      // }
      // minutes = minutes >= 10 ? minutes : "0" + minutes;
      // // this.movieSelected.start_time = hours + ":" + minutes + " " + ampm;
      // return hours + ":" + minutes + " " + ampm;
    },
    getScheduleCheckerOnRun: function () {
      // if (type == "edit") {
      //   let currentDate = this.movieSelectedTimeCopy;
      //   currentDate = +new Date(currentDate);
      //   console.log("currentDate :", currentDate);
      //   let end_time = moment(this.movieSelectedTimeCopy)
      //     .add(parseInt(this.movieSelected.lengthMinutes), "m")
      //     .toDate();

      //   end_time = +new Date(end_time);

      //   // let startTime = this.onChangeTimePicker(this.movieSelected.start_time);
      //   // // let endTime = this.onChangeTimePicker(this.movieSelected.start_time);
      //   // let start = 0;
      //   // let hours = 0;
      //   // let minutes = 0;
      //   // let totalMinutes = 0;
      //   // this.movieSelected.start_time = this.onChangeTimePicker(
      //   //   this.movieSelected.start_time
      //   // );
      //   // let ampm = this.movieSelected.start_time.split(" ")[1]; //AM PM
      //   // let time = this.movieSelected.start_time.split(" ")[0]; //AM PM
      //   // minutes = parseInt(time.split(":")[1]); //"8:30 PM"// 30 PM
      //   // hours = parseInt(time.split(":")[0]); //
      //   // if (ampm == "PM") {
      //   //   hours = hours + 12;
      //   // }
      //   // totalMinutes = parseInt(hours * 60) + minutes;
      //   // start = parseInt(totalMinutes * 30) / 10;

      //   // this.movieSelected.start = start;
      //   // this.movieSelected.zIndex = 99;

      // } else {
      let currentDate = this.movieSelected.selected_time;
      currentDate = +new Date(currentDate);
      console.log("currentDate :", currentDate);
      let end_time = moment(this.movieSelected.selected_time)
        .add(parseInt(this.movieSelected.lengthMinutes), "m")
        .toDate();

      end_time = +new Date(end_time);

      // let startTime = this.onChangeTimePicker(this.movieSelected.start_time);
      // // let endTime = this.onChangeTimePicker(this.movieSelected.start_time);
      // let start = 0;
      // let hours = 0;
      // let minutes = 0;
      // let totalMinutes = 0;
      // this.movieSelected.start_time = this.onChangeTimePicker(
      //   this.movieSelected.start_time
      // );
      // let ampm = this.movieSelected.start_time.split(" ")[1]; //AM PM
      // let time = this.movieSelected.start_time.split(" ")[0]; //AM PM
      // minutes = parseInt(time.split(":")[1]); //"8:30 PM"// 30 PM
      // hours = parseInt(time.split(":")[0]); //
      // if (ampm == "PM") {
      //   hours = hours + 12;
      // }
      // totalMinutes = parseInt(hours * 60) + minutes;
      // start = parseInt(totalMinutes * 30) / 10;

      // this.movieSelected.start = start;
      // this.movieSelected.zIndex = 99;
      this.convertToTime(
        this.movieSelected.start,
        this.movieSelected.lengthMinutes
      );
      // }
      // let currentDate = this.movieSelected.selected_time;
      // currentDate = +new Date(currentDate);
      // console.log("currentDate :", currentDate);
      // let end_time = moment(this.movieSelected.selected_time)
      //   .add(parseInt(this.movieSelected.lengthMinutes), "m")
      //   .toDate();

      // end_time = +new Date(end_time);

      // let startTime = this.onChangeTimePicker(this.movieSelected.start_time);
      // // let endTime = this.onChangeTimePicker(this.movieSelected.start_time);
      // let start = 0;
      // let hours = 0;
      // let minutes = 0;
      // let totalMinutes = 0;
      // this.movieSelected.start_time = this.onChangeTimePicker(
      //   this.movieSelected.start_time
      // );
      // let ampm = this.movieSelected.start_time.split(" ")[1]; //AM PM
      // let time = this.movieSelected.start_time.split(" ")[0]; //AM PM
      // minutes = parseInt(time.split(":")[1]); //"8:30 PM"// 30 PM
      // hours = parseInt(time.split(":")[0]); //
      // if (ampm == "PM") {
      //   hours = hours + 12;
      // }
      // totalMinutes = parseInt(hours * 60) + minutes;
      // start = parseInt(totalMinutes * 30) / 10;

      // this.movieSelected.start = start;
      // this.movieSelected.zIndex = 99;

      console.log("this.movieSelected :", this.movieSelected);

      return new Promise((resolve, reject) => {
        // let payload = {
        //   cinema_id: this.scheduleObject.cinema_id,
        //   start_date: moment(this.movieSelected.ss_start_date).format(
        //     "YYYY-MM-DD"
        //   ),
        //   end_date: moment(this.movieSelected.ss_end_date).format("YYYY-MM-DD")
        // };
        // scheduleService.GetCinemaSchedule(payload)
        //   .then(result => {
        // const { data } = result;

        // this.selectedMoviesInScreen = [{ screenid : 1, movies :[]
        // }]
        if (
          this.selectedMoviesInScreens[this.selectedScreenIndex]["movies"]
            .length > 0
        ) {
          let newRecords =
            this.selectedMoviesInScreens[this.selectedScreenIndex]["movies"];
          let screenID =
            this.selectedMoviesInScreens[this.selectedScreenIndex]["screen_id"];
          let array = [];

          for (
            let index = 0;
            index <
            this.selectedMoviesInScreens[this.selectedScreenIndex]["movies"]
              .length;
            index++
          ) {
            const element = newRecords[index];
            console.log("element :", element);

            let old_movie_start_date = element.selected_time;
            old_movie_start_date = moment(old_movie_start_date).valueOf();
            console.log("old_movie_start_date :", old_movie_start_date);
            let old_movie_end_date = moment(element.selected_time)
              .add(parseInt(element.lengthMinutes), "m")
              .toDate();

            old_movie_end_date = moment(old_movie_end_date).valueOf(); // +new Date(old_movie_end_date);

            // let old_movie_start_date = moment
            //   .unix(element.ss_start_date_time)
            //   .format("YYYY-MM-DD HH:mm:ss");
            // let old_movie_end_date = moment
            //   .unix(element.ss_end_date_time)
            //   .format("YYYY-MM-DD HH:mm:ss");
            old_movie_start_date = moment(old_movie_start_date).format(
              "YYYY-MM-DD HH:mm:ss"
            );
            old_movie_end_date = moment(old_movie_end_date).format(
              "YYYY-MM-DD HH:mm:ss"
            );

            let new_movie_end_date = moment(end_time).format(
              "YYYY-MM-DD HH:mm:ss"
            );
            let new_movie_start_date = moment(currentDate).format(
              "YYYY-MM-DD HH:mm:ss"
            );
            // console.log("ss_start_date_time", ss_start_date_time);
            console.log("old_movie_start_date :", old_movie_start_date);
            console.log("old_movie_end_date :", old_movie_end_date);
            console.log("new_movie_start_date :", new_movie_start_date);
            console.log("new_movie_end_date", new_movie_end_date);
            // console.log("selected_end_time", selected_end_time);
            // let valid =
            //   element.ss_start_date_time <= currentDate &&
            //   element.ss_end_date_time >= currentDate;

            let valid = moment(old_movie_end_date).isBetween(
              new_movie_start_date,
              new_movie_end_date
            );
            let validSame =
              moment(old_movie_end_date).isSame(new_movie_end_date);
            let validSame1 =
              moment(old_movie_start_date).isSame(new_movie_start_date);
            let valid1 = moment(new_movie_end_date).isBetween(
              old_movie_start_date,
              old_movie_end_date
            );

            console.log(
              "valid , validSame , validSame1 , valid1 :",
              valid,
              validSame,
              validSame1,
              valid1
            );
            // moment(selected_end_time).isBetween(
            //   ss_start_date_time,
            //   ss_end_date_time
            // );

            // console.log("valid :", valid);
            // console.log("element.screen_id :", element.screen_id);
            // console.log(
            //   "object :",
            //   this.selectedMoviesInScreens[this.selectedScreenIndex]
            //     .screen_id
            // );

            // valid = !valid
            //   ? moment(ss_end_date_time).isBetween(
            //       ss_start_date_time,
            //       selected_end_time
            //     )
            //   : valid;
            console.log(
              "this.selectedScreen.screen_id ,  :",
              this.selectedScreen.screen_id,
              this.selectedMoviesInScreens[this.selectedScreenIndex].screen_id
            );
            console.log(
              "aaaaaaasssssssssss :",
              this.selectedScreen.screen_id ==
                this.selectedMoviesInScreens[this.selectedScreenIndex].screen_id
            );

            if (
              this.selectedScreen.screen_id ==
                this.selectedMoviesInScreens[this.selectedScreenIndex]
                  .screen_id &&
              valid1
            ) {
              resolve({
                status: false,
                message:
                  "Your movie added overlaps with " +
                  element.movie_title +
                  " as that is scheduled between " +
                  element.start_time +
                  " to " +
                  element.end_time +
                  " on " +
                  moment(element.ss_start_date, "YYYY-MM-DD").format(
                    "DD MMMM, YYYY"
                  ),
              });
              break;
            } else if (
              this.selectedScreen.screen_id ==
                this.selectedMoviesInScreens[this.selectedScreenIndex]
                  .screen_id &&
              valid
            ) {
              resolve({
                status: false,
                message:
                  "Your movie added overlaps with " +
                  element.movie_title +
                  " as that is scheduled between " +
                  element.start_time +
                  " to " +
                  element.end_time +
                  " on " +
                  moment(element.ss_start_date, "YYYY-MM-DD").format(
                    "DD MMMM, YYYY"
                  ),
              });
              break;
            } else if (
              this.selectedScreen.screen_id ==
                this.selectedMoviesInScreens[this.selectedScreenIndex]
                  .screen_id &&
              validSame
            ) {
              resolve({
                status: false,
                message:
                  "Your movie added overlaps with " +
                  element.movie_title +
                  " as that is scheduled between " +
                  element.start_time +
                  " to " +
                  element.end_time +
                  " on " +
                  moment(element.ss_start_date, "YYYY-MM-DD").format(
                    "DD MMMM, YYYY"
                  ),
              });
              break;
            } else if (
              this.selectedScreen.screen_id ==
                this.selectedMoviesInScreens[this.selectedScreenIndex]
                  .screen_id &&
              validSame1
            ) {
              resolve({
                status: false,
                message:
                  "Your movie added overlaps with " +
                  element.movie_title +
                  " as that is scheduled between " +
                  element.start_time +
                  " to " +
                  element.end_time +
                  " on " +
                  moment(element.ss_start_date, "YYYY-MM-DD").format(
                    "DD MMMM, YYYY"
                  ),
              });
              break;
            } else {
              array.push(element.ss_start_show_time);
              if (array.length === newRecords.length) {
                resolve({ status: true });
              }
            }
          }
        } else {
          resolve({ status: true });
        }
      });
    },

    getScheduleChecker: function () {
      console.log("this.movieSelected :", this.movieSelected);
      let currentDate = "";
      let end_time = "";
      if (
        moment(
          moment().format("YYYY-MM-DD") +
            " " +
            this.CinemasSettings.cine_operation_start_time
        ).isSameOrAfter(
          moment(
            moment().format("YYYY-MM-DD") +
              " " +
              this.CinemasSettings.cine_operation_end_time
          )
        )
      ) {
        console.log("-----------------COME1-----------------");

        if (
          moment(
            moment().format("YYYY-MM-DD") +
              " " +
              this.CinemasSettings.cine_operation_end_time
          ).isAfter(
            moment(
              moment().format("YYYY-MM-DD") +
                " " +
                moment(this.movieSelected.selected_time).format("HH:mm")
            )
          )
        ) {
          console.log("-----------------COME2-----------------");

          currentDate =
            moment(this.movieSelected.ss_start_date)
              .add(1, "days")
              .format("YYYY-MM-DD") +
            " " +
            moment(this.movieSelected.selected_time).format("HH:mm");
          currentDate = moment(currentDate).valueOf();

          end_time = moment(
            moment(this.movieSelected.ss_start_date)
              .add(1, "days")
              .format("YYYY-MM-DD") +
              " " +
              moment(this.movieSelected.selected_time).format("HH:mm")
          )
            .add(parseInt(this.movieSelected.lengthMinutes), "m")
            .toDate();

          end_time = moment(end_time).valueOf();
        } else {
          console.log("-----------------COME3-----------------");
          console.log("this.movieSelected :", this.movieSelected);
          console.log("this.movieSelected :", typeof this.movieSelected);

          currentDate =
            moment(this.movieSelected.ss_start_date).format("YYYY-MM-DD") +
            " " +
            moment(this.movieSelected.selected_time).format("HH:mm");
          console.log("currentDate aaaaaaaaaaaaaaaaa:", currentDate);

          currentDate = moment(currentDate).valueOf();
          console.log(
            "currentDate aaaaaaaaaabbbbbbbbbbbbaaaaaaa:",
            currentDate
          );
          end_time = moment(
            moment(this.movieSelected.ss_start_date).format("YYYY-MM-DD") +
              " " +
              moment(this.movieSelected.selected_time).format("HH:mm")
          )
            .add(parseInt(this.movieSelected.lengthMinutes), "m")
            .toDate();

          end_time = moment(end_time).valueOf();
        }
      } else {
        console.log("-----------------LAST MAIN ELSE-----------------");
        console.log("this.movieSelected :", this.movieSelected);

        currentDate =
          moment(this.movieSelected.ss_start_date).format("YYYY-MM-DD") +
          " " +
          moment(this.movieSelected.selected_time).format("HH:mm");
        console.log("currentDate aaaaaaaaaaaaaaaaa:", currentDate);

        currentDate = moment(currentDate).valueOf();
        console.log("currentDate aaaaaaaaaabbbbbbbbbbbbaaaaaaa:", currentDate);
        end_time = moment(
          moment(this.movieSelected.ss_start_date).format("YYYY-MM-DD") +
            " " +
            moment(this.movieSelected.selected_time).format("HH:mm")
        )
          .add(parseInt(this.movieSelected.lengthMinutes), "m")
          .toDate();

        end_time = moment(end_time).valueOf();
      }
      console.log("currentDate , end_time :", currentDate, end_time);

      // let startTime = this.onChangeTimePicker(this.movieSelected.start_time);
      // // let endTime = this.onChangeTimePicker(this.movieSelected.start_time);
      // let start = 0;
      // let hours = 0;
      // let minutes = 0;
      // let totalMinutes = 0;
      // this.movieSelected.start_time = this.onChangeTimePicker(
      //   this.movieSelected.start_time
      // );
      // let ampm = this.movieSelected.start_time.split(" ")[1]; //AM PM
      // let time = this.movieSelected.start_time.split(" ")[0]; //AM PM
      // minutes = parseInt(time.split(":")[1]); //"8:30 PM"// 30 PM
      // hours = parseInt(time.split(":")[0]); //
      // if (ampm == "PM") {
      //   hours = hours + 12;
      // }
      // totalMinutes = parseInt(hours * 60) + minutes;
      // start = parseInt(totalMinutes * 30) / 10;

      // this.movieSelected.start = start;
      // this.movieSelected.zIndex = 99;
      this.convertToTime(
        this.movieSelected.start,
        this.movieSelected.lengthMinutes
      );

      console.log("this.movieSelected :", this.movieSelected);

      return new Promise((resolve, reject) => {
        let payload = {
          cinema_id: this.scheduleObject.cinema_id,
          start_date: moment(this.movieSelected.ss_start_date).format(
            "YYYY-MM-DD"
          ),
          end_date: moment(this.movieSelected.ss_end_date).format("YYYY-MM-DD"),
          is_active: "Y",
        };
        scheduleService
          .GetAllCinemaSchedule(payload)
          .then((result) => {
            const { data } = result;
            if (data && data.status && data.Records.length > 0) {
              let newRecords = data.Records;
              console.log("newRecords :", newRecords);
              let array = [];

              for (let index = 0; index < newRecords.length; index++) {
                const element = newRecords[index];

                let old_movie_start_date = moment(
                  moment(element.ss_actual_start_date).format("YYYY-MM-DD") +
                    " " +
                    moment(element.ss_start_show_time, "HH:mm").format("HH:mm")
                ).format("YYYY-MM-DD HH:mm:ss");
                let old_movie_end_date = moment(
                  moment(element.ss_actual_end_date).format("YYYY-MM-DD") +
                    " " +
                    moment(element.ss_end_show_time, "HH:mm").format("HH:mm")
                ).format("YYYY-MM-DD HH:mm:ss");
                let new_movie_end_date = moment(end_time).format(
                  "YYYY-MM-DD HH:mm:ss"
                );
                let new_movie_start_date = moment(currentDate).format(
                  "YYYY-MM-DD HH:mm:ss"
                );
                // console.log("ss_start_date_time", ss_start_date_time);
                console.log("old_movie_start_date :", old_movie_start_date);
                console.log("old_movie_end_date :", old_movie_end_date);
                console.log("new_movie_start_date :", new_movie_start_date);
                console.log("new_movie_end_date", new_movie_end_date);

                // console.log("selected_end_time", selected_end_time);
                // let valid =
                //   element.ss_start_date_time <= currentDate &&
                //   element.ss_end_date_time >= currentDate;

                let valid = moment(old_movie_end_date).isBetween(
                  new_movie_start_date,
                  new_movie_end_date
                );
                let validSame =
                  moment(old_movie_end_date).isSame(new_movie_end_date);
                let validSame1 =
                  moment(old_movie_start_date).isSame(new_movie_start_date);
                let valid1 = moment(new_movie_end_date).isBetween(
                  old_movie_start_date,
                  old_movie_end_date
                );

                console.log(valid, validSame, validSame1, valid1); // moment(selected_end_time).isBetween(
                //   ss_start_date_time,
                //   ss_end_date_time
                // );

                // console.log("valid :", valid);
                // console.log("element.screen_id :", element.screen_id);
                // console.log(
                //   "object :",
                //   this.selectedMoviesInScreens[this.selectedScreenIndex]
                //     .screen_id
                // );

                // valid = !valid
                //   ? moment(ss_end_date_time).isBetween(
                //       ss_start_date_time,
                //       selected_end_time
                //     )
                //   : valid;

                if (
                  element.screen_id ==
                    this.selectedMoviesInScreens[this.selectedScreenIndex]
                      .screen_id &&
                  valid1
                ) {
                  resolve({
                    status: false,
                    // Your movie added overlaps with the Dark Knight as that is scheduled between 13:30 to 15:30 on the 21 July, 2020
                    message:
                      "Your movie added overlaps with " +
                      element.movie_title +
                      " as that is scheduled between " +
                      element.ss_start_show_time +
                      " to " +
                      element.ss_end_show_time +
                      " on " +
                      moment(element.ss_start_date, "YYYY-MM-DD").format(
                        "DD MMMM, YYYY"
                      ),
                  });
                  break;
                } else if (
                  element.screen_id ==
                    this.selectedMoviesInScreens[this.selectedScreenIndex]
                      .screen_id &&
                  valid
                ) {
                  resolve({
                    status: false,
                    message:
                      "Your movie added overlaps with " +
                      element.movie_title +
                      " as that is scheduled between " +
                      element.ss_start_show_time +
                      " to " +
                      element.ss_end_show_time +
                      " on " +
                      moment(element.ss_start_date, "YYYY-MM-DD").format(
                        "DD MMMM, YYYY"
                      ),
                  });
                  break;
                } else if (
                  element.screen_id ==
                    this.selectedMoviesInScreens[this.selectedScreenIndex]
                      .screen_id &&
                  validSame
                ) {
                  resolve({
                    status: false,
                    message:
                      "Your movie added overlaps with " +
                      element.movie_title +
                      " as that is scheduled between " +
                      element.ss_start_show_time +
                      " to " +
                      element.ss_end_show_time +
                      " on " +
                      moment(element.ss_start_date, "YYYY-MM-DD").format(
                        "DD MMMM, YYYY"
                      ),
                  });
                  break;
                } else if (
                  element.screen_id ==
                    this.selectedMoviesInScreens[this.selectedScreenIndex]
                      .screen_id &&
                  validSame1
                ) {
                  resolve({
                    status: false,
                    message:
                      "Your movie added overlaps with " +
                      element.movie_title +
                      " as that is scheduled between " +
                      element.ss_start_show_time +
                      " to " +
                      element.ss_end_show_time +
                      " on " +
                      moment(element.ss_start_date, "YYYY-MM-DD").format(
                        "DD MMMM, YYYY"
                      ),
                  });
                  break;
                } else {
                  array.push(element.ss_start_show_time);
                  if (array.length === newRecords.length) {
                    resolve({ status: true });
                  }
                }
              }
            } else {
              resolve({ status: true });
            }
          })
          .catch((error) => {
            console.log("err :", error);
            resolve({ status: false, message: "overlaps", error: error });
          });
      });
    },
    onUpdate: function (RemoveOldMovie) {
      console.log("hello manav1");

      this.soundFormatError = false;
      this.videoFormatError = false;
      this.licenseDateError = false;

      // movie-screen video format validation
      if (this.selectedScreen.videoFormats && this.selectedMovie.mf_id) {
        console.log({ "his.selectedMovie": this.selectedMovie });
        console.log({ "his.selectedScreen": this.selectedScreen });

        let videoFormats = this.selectedScreen.videoFormats.map(
          (vf) => vf.mf_id
        );
        console.log({ videoFormats, mf_id: this.selectedMovie.mf_id });

        if (!videoFormats.includes(this.selectedMovie.mf_id)) {
          this.$toasted.show(this.$t("videoFormatErrorPopup"));
          this.videoFormatError = true;
          return;
        } else {
          this.videoFormatError = false;
        }
      }

      // movie-screen sound format validation
      if (
        this.selectedScreen.soundFormats &&
        this.selectedScreen.soundFormats.length &&
        this.selectedMovie.sound_format_id
      ) {
        console.log({ "his.selectedMovie": this.selectedMovie });
        console.log({ "his.selectedScreen": this.selectedScreen });

        let soundFormats = this.selectedScreen.soundFormats.map(
          (sf) => sf.sound_format_id
        );
        console.log({
          soundFormats,
          sound_format_id: this.selectedMovie.sound_format_id,
        });

        if (!soundFormats.includes(this.selectedMovie.sound_format_id)) {
          this.$toasted.show(this.$t("soundFormatErrorPopup"));
          this.soundFormatError = true;
          return;
        } else {
          this.soundFormatError = false;
        }
      }

      // movie license date validation
      console.log(
        this.movieSelected.ss_start_date,
        this.movieSelected.ss_end_date
      );
      console.log(
        this.selectedMovie.mss_ss_start_date,
        this.selectedMovie.mss_ss_end_date
      );

      if (
        this.selectedMovie.hasOwnProperty("mss_ss_start_date") &&
        this.selectedMovie.hasOwnProperty("mss_ss_end_date")
      ) {
        if (
          !this.selectedMovie.mss_ss_start_date ||
          !this.selectedMovie.mss_ss_end_date
        ) {
          this.$toasted.show(this.$t("licenseDateErrorPopup"));
          this.licenseDateError = true;
          // return;
        }

        if (
          !!this.movieSelected.ss_start_date &&
          !!this.movieSelected.ss_end_date
        ) {
          let startDate = moment(this.movieSelected.ss_start_date);
          let endDate = moment(this.movieSelected.ss_end_date);
          let licStartDate = moment(this.selectedMovie.mss_ss_start_date);
          let licEndDate = moment(this.selectedMovie.mss_ss_end_date);

          console.log({
            startDate: startDate.format("DD-MM-YYYY"),
            endDate: endDate.format("DD-MM-YYYY"),
            licStartDate: licStartDate.format("DD-MM-YYYY"),
            licEndDate: licEndDate.format("DD-MM-YYYY"),
          });

          if (
            !startDate.isBetween(licStartDate, licEndDate, "days", "[]") // all inclusive
          ) {
            this.$toasted.show(this.$t("licenseDatePastErrorPopup"));
            console.log("Start date is not between licStart, licEnd");
            this.licenseDateError = true;
            // return;
          }

          if (
            !endDate.isBetween(licStartDate, licEndDate, "days", "[]") // all inclusive
          ) {
            this.$toasted.show(
              this.$t("licenseDateExpiresBeforeScheduleErrorPopup")
            );
            console.log("End date is not between licStart, licEnd");
            this.licenseDateError = true;
            // return
          }

          this.licenseDateError = false;
        }
      }
      this.btenable = true;
      this.movieSelected.interval_time_in_mins =
        this.selectedCinemaSettings.interval_time_in_mins;
      this.movieSelected.cleaning_time_in_mins =
        this.selectedCinemaSettings.cleaning_time_in_mins;
      this.movieSelected.ads_time_in_mins =
        this.selectedCinemaSettings.ads_time_in_mins;

      this.movieSelected.lengthMinutes =
        parseInt(this.movieSelected.mrrdr_runtime) +
        parseInt(this.movieSelected.cleaning_time_in_mins) +
        parseInt(this.movieSelected.ads_time_in_mins) +
        parseInt(this.movieSelected.interval_time_in_mins);

      this.movieSelected.length = this.movieSelected.lengthMinutes * 3;
      console.log(
        "🚀 ~ file: schedule2.vue ~ line 2297 ~ this.movieSelected",
        this.movieSelected
      );
      console.log(
        "🚀 ~ file: schedule2.vue ~ line 2289 ~ this.selectedCinemaSettings",
        this.selectedCinemaSettings
      );
      // console.log(
      //   "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
      //   this.selectedMoviesInScreens[this.selectedScreenIndex]["movies"]
      // );
      if (RemoveOldMovie && RemoveOldMovie === "RemoveOldMovie") {
        // this.selectedMoviesInScreens[this.selectedScreenIndex]["movies"] = []
        //

        if (this.selectedMoviesInScreens[this.selectedScreenIndex]["movies"]) {
          this.movieSelectedCopy =
            this.selectedMoviesInScreens[this.selectedScreenIndex]["movies"][
              this.movieSelectedIndex
            ];
          this.selectedMoviesInScreens[this.selectedScreenIndex][
            "movies"
          ].splice(this.movieSelectedIndex, 1);
        }
      }
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        // let array = this.movieSelected.scheduleShowPrice.filter(x => {
        let array = this.movieSelected.scheduleShowPrice.filter((x) => {
          return x.rate_card_name != "Select Rate Card";
        });
        if (
          valid &&
          this.selectedScreenSeatTypes &&
          this.selectedScreenSeatTypes.length > 0 &&
          this.movieSelected.scheduleShowPrice &&
          array.length == this.movieSelected.scheduleShowPrice.length &&
          String(this.selectedScreenIndex).length > 0
        ) {
          if (valid) {
            this.btenable = true;
            this.isScheduleAdded = true;
            let count = 0;
            //Get schedules
            this.getScheduleCheckerOnRun().then((result) => {
              console.log("result :>> ", result);
              this.btenable = false;
              if (!result.status) {
                //Assuming there is a overlap with data in the frontend itself
                if (RemoveOldMovie && RemoveOldMovie === "RemoveOldMovie") {
                  this.selectedMoviesInScreens[this.selectedScreenIndex][
                    "movies"
                  ].push(this.movieSelectedCopy);
                  this.$refs.updateMovie.hide();
                } else {
                  this.selectedMovie = [];
                  this.submitted = false;
                  this.btenable = false;
                  this.selectedScreenSeatTypes = [];
                  this.screen_seat_card_mapping = [];
                  this.movieSelected = {
                    ...this.movieSelected,
                    md_id: "",
                    movie_id: "",
                    movie_title: "",
                    lang_name: "",
                    md_thumbnail_url: "",
                    mf_name: "",
                    movie_is_active: "",
                    rating: "",
                    mrrdr_runtime: "",
                    mrrdr_release_date: "",
                    lengthMinutes: "",
                    length: "",
                    rateCard: [],
                    scheduleShowPrice: [
                      {
                        rate_card_id: "",
                        searchRateCard: "",
                        rate_card_name: "",
                        schedule_show_id: "",
                        screen_seat_type_id: "",
                        p_start_date_time: null,
                        p_end_date_time: null,
                        p_is_active: "Y",
                      },
                    ],
                  };
                }
                this.movieSelectedCopy = "";
                this.$toasted.show(result.message);
              } else {
                this.getScheduleChecker()
                  .then((result) => {
                    console.log("result1 :>> ", result);
                    if (!result.status) {
                      if (
                        RemoveOldMovie &&
                        RemoveOldMovie === "RemoveOldMovie"
                      ) {
                        console.log(
                          "this.movieSelectedCopy :",
                          this.movieSelectedCopy
                        );
                        this.selectedMoviesInScreens[this.selectedScreenIndex][
                          "movies"
                        ].push(this.movieSelectedCopy);
                        this.$refs.updateMovie.hide();
                      } else {
                        this.selectedMovie = [];
                        this.submitted = false;
                        this.btenable = false;
                        this.selectedScreenSeatTypes = [];
                        this.screen_seat_card_mapping = [];
                        this.movieSelected = {
                          ...this.movieSelected,

                          md_id: "",
                          movie_id: "",
                          movie_title: "",
                          lang_name: "",
                          md_thumbnail_url: "",
                          mf_name: "",
                          movie_is_active: "",
                          rating: "",
                          mrrdr_runtime: "",
                          mrrdr_release_date: "",
                          lengthMinutes: "",
                          length: "",
                          rateCard: [],
                          scheduleShowPrice: [
                            {
                              rate_card_id: "",
                              rate_card_name: "",
                              searchRateCard: "",
                              schedule_show_id: "",
                              screen_seat_type_id: "",
                              p_start_date_time: null,
                              p_end_date_time: null,
                              p_is_active: "Y",
                            },
                          ],
                        };
                      }
                      this.$toasted.show(result.message);
                    } else if (result.status) {
                      let start = 0;
                      let hours = 0;
                      let minutes = 0;
                      let totalMinutes = 0;

                      this.movieSelected.start_time = this.onChangeTimePicker(
                        this.movieSelected.selected_time
                      );
                      this.movieSelected.selected_time_copy =
                        this.movieSelected.selected_time;

                      let cinema_start = this.getScreenPositionCalc(
                        this.CinemasSettings.cine_operation_start_time
                      );
                      // let show_start_time = ref.getScreenPositionCalc(startTime);
                      // let show_start_time = this.getScreenPositionCalc(
                      //   this.movieSelected.start_time
                      // );

                      //  24 hour setting

                      let show_start_time = ""; //ref.getScreenPositionCalc(startTime);
                      if (
                        moment(
                          moment()
                            .tz(this.timeZone.tz_name)
                            .format("YYYY-MM-DD") +
                            " " +
                            this.CinemasSettings.cine_operation_end_time
                        )
                          .tz(this.timeZone.tz_name)
                          .format("HH:mm") <=
                        moment(
                          moment()
                            .tz(this.timeZone.tz_name)
                            .format("YYYY-MM-DD") +
                            " " +
                            this.CinemasSettings.cine_operation_start_time
                        )
                          .tz(this.timeZone.tz_name)
                          .format("HH:mm")
                      ) {
                        console.log("camehere11111 :");
                        if (
                          moment(
                            moment()
                              .tz(this.timeZone.tz_name)
                              .format("YYYY-MM-DD") +
                              " " +
                              this.CinemasSettings.cine_operation_end_time
                          ).isAfter(
                            moment(
                              moment()
                                .tz(this.timeZone.tz_name)
                                .format("YYYY-MM-DD") +
                                " " +
                                this.movieSelected.start_time
                            )
                          )
                        ) {
                          show_start_time =
                            4320 +
                            this.getScreenPositionCalc(
                              this.movieSelected.start_time
                            );
                        } else {
                          console.log("camehere222222222222 :");

                          show_start_time = this.getScreenPositionCalc(
                            this.movieSelected.start_time
                          );
                        }
                      } else {
                        console.log("camehere333333333333333333333 :");

                        show_start_time = this.getScreenPositionCalc(
                          this.movieSelected.start_time
                        );
                      }

                      console.log("this.show_start_time :", show_start_time);

                      let start_delay = this.getScreenPositionCalc("00:30");
                      console.log(
                        "show_start_time , cinema_start , start_delay :",
                        show_start_time,
                        cinema_start,
                        start_delay
                      );
                      start = show_start_time - cinema_start + start_delay;
                      // let ampm = this.movieSelected.start_time.split(" ")[1]; //AM PM
                      // let time = this.movieSelected.start_time.split(" ")[0]; //AM PM
                      // minutes = parseInt(time.split(":")[1]); //"8:30 PM"// 30 PM
                      // hours = parseInt(time.split(":")[0]); //

                      // if (ampm == "PM") {
                      //   if (hours == 12) {
                      //     //do nothing
                      //   } else {
                      //     hours = hours + 12;
                      //   }
                      // }
                      // console.log("ampm :", ampm);
                      // console.log("minutes :", minutes);
                      // console.log("hours :", hours);
                      // totalMinutes = parseInt(hours * 60) + minutes;
                      // start = parseInt(totalMinutes * 30) / 10;
                      this.movieSelected.start = start;
                      this.movieSelected.zIndex = 99;

                      // this.selectedMoviesInScreens[this.selectedScreenIndex]["movies"].push(
                      //   this.movieSelected
                      // );

                      // let start = 0;
                      // let hours = 0;
                      // let minutes = 0;
                      // let totalMinutes = 0;
                      // this.movieSelected.start_time = this.onChangeTimePicker(
                      //   this.movieSelected.start_time
                      // );
                      // let ampm = this.movieSelected.start_time.split(" ")[1]; //AM PM
                      // let time = this.movieSelected.start_time.split(" ")[0]; //AM PM
                      // minutes = parseInt(time.split(":")[1]); //"8:30 PM"// 30 PM
                      // hours = parseInt(time.split(":")[0]); //

                      // if (ampm == "PM") {
                      //   hours = hours + 12;
                      // }
                      // totalMinutes = parseInt(hours * 60) + minutes;
                      // start = parseInt(totalMinutes * 30) / 10;
                      // this.movieSelected.start = start;
                      // this.movieSelected.zIndex = 99;

                      this.$refs.test.hide();
                      this.$refs.updateMovie.hide();
                      // console.log(
                      //   "this???????????????????????? :",
                      //   this.selectedMoviesInScreens
                      // );

                      this.selectedMoviesInScreens[this.selectedScreenIndex][
                        "movies"
                      ].push(this.movieSelected);
                    }
                    // console.log("object :", this.movieSelected);
                    // console.log(
                    //   "this.seaaaaaaaaaaaaaaaaaa :",
                    //   this.selectedMoviesInScreens[this.selectedScreenIndex][
                    //     "movies"
                    //   ]
                    // );
                    this.selectedMovie = [];
                    this.submitted = false;
                    this.btenable = false;
                    this.selectedScreenSeatTypes = [];
                    this.screen_seat_card_mapping = [];
                    this.movieSelected = {
                      ...this.movieSelected,

                      md_id: "",
                      movie_id: "",
                      movie_title: "",
                      lang_name: "",
                      md_thumbnail_url: "",
                      mf_name: "",
                      movie_is_active: "",
                      rating: "",
                      mrrdr_runtime: "",
                      mrrdr_release_date: "",
                      lengthMinutes: "",
                      length: "",
                      rateCard: [],
                      scheduleShowPrice: [
                        {
                          rate_card_id: "",
                          rate_card_name: "",
                          searchRateCard: "",
                          schedule_show_id: "",
                          screen_seat_type_id: "",
                          p_start_date_time: null,
                          p_end_date_time: null,
                          p_is_active: "Y",
                        },
                      ],
                    };
                  })
                  .catch((err) => {});
              }
            });
          } else {
            this.btenable = false;
          }
          // let payload = {
          //   show_schedule_id: this.movieSelected.scheduleShowPrice[0]
          //     .schedule_show_id,
          //   screen_id: this.movieSelected.scheduleShowPrice[0].screen_id,
          //   ss_start_show_time: this.movieSelected.start_time,
          //   ss_end_show_time: this.movieSelected.end_time
          // }

          // this.$refs.updateMovie.hide();
        } else {
          this.btenable = false;
          console.log("valid :", valid);
        }
        this.btenable = false;
        // });
      });
    },
    getScreenPositionCalc: function (start_time) {
      let cinema_start_time = this.CinemasSettings.cine_operation_start_time;
      let cinema_ampm = cinema_start_time.split(" ")[1];
      let cinema_minutes = parseInt(cinema_start_time.split(":")[1]);
      let cinema_hours = parseInt(cinema_start_time.split(":")[0]);

      let start = 0;
      let cinema_start = 0;
      let hours = 0;
      let minutes = 0;
      let totalMinutes = 0;
      let ampm = start_time.split(" ")[1];
      minutes = parseInt(start_time.split(":")[1]);
      hours = parseInt(start_time.split(":")[0]);
      if (ampm == "PM" && hours === 12) {
        hours = hours;
      } else if (ampm == "PM") {
        hours = hours + 12;
      }
      // if(cinema_hours < hours){
      //   hours =
      // }
      if (ampm == "AM" && hours === 12) {
        totalMinutes = minutes;
        cinema_start = parseInt(totalMinutes * 30) / 10;
        return cinema_start;
      } else {
        totalMinutes = parseInt(hours * 60) + minutes;
        cinema_start = parseInt(totalMinutes * 30) / 10;
        return cinema_start;
      }

      totalMinutes = parseInt(hours * 60) + minutes;
      cinema_start = parseInt(totalMinutes * 30) / 10;
      return cinema_start;
    },

    tConvert: function (time) {
      // Check correct time format and split into components
      time = time
        .toString()
        .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
      if (time.length > 1) {
        // If time format correct
        time = time.slice(1); // Remove full string match value
        time[5] = +time[0] < 12 ? "AM" : "PM"; // Set AM/PM
        time[0] = +time[0] % 12 || 12; // Adjust hours
      }
      return { digit: time[0], join: time.join("") }; // return adjusted time or original string
    },

    submitSchedule: async function (status_id) {
      let self = this;
      // this.selectedMoviesInScreens.map((screen, screenIndex) => {
      //   this.screen.movie.map((singleMovie, singleMovieIndex) => {
      //     singleMovie.startTime = singleMovie.start;
      //     return singleMovie;
      //   });
      //   //API Call schedule
      // });

      this.FinalArray = [];
      let dates = [];
      // let dates = getDates(
      //   moment(this.scheduleObject.sch_start_date).format("YYYY-MM-DD"),
      //   moment(this.scheduleObject.sch_end_date).format("YYYY-MM-DD")
      // );
      console.log(
        "this.selectedMoviesInScreens :",
        this.selectedMoviesInScreens
      );
      this.FinalScreenAndMovieScheduleList =
        this.selectedMoviesInScreens.filter((x) => {
          return x.movies.length > 0;
        });

      this.FinalScreenAndMovieScheduleList.map((x) => {
        x.movies.map((y) => {
          console.log(y);
          dates = getDates(y.ss_start_date, y.ss_end_date);
        });
      });

      function getDates(startDate, stopDate) {
        console.log("startDate :", startDate);
        console.log("stopDate :", stopDate);
        console.log("this :", self);
        console.log("this.timeZone :", self.timeZone);
        var dateArray = [];
        var currentDate = moment(startDate);
        var stopDate = moment(stopDate);
        while (currentDate <= stopDate) {
          dateArray.push(moment(currentDate).format("YYYY-MM-DD"));
          currentDate = moment(currentDate).add(1, "days");
        }
        console.log("dateArray :", dateArray);
        return dateArray;
      }

      console.log("dates :", dates);
      let dateCount = 0;

      let finalpromises = self.FinalScreenAndMovieScheduleList.map(
        async (item, itemIndex) => {
          let MainObj = {};
          MainObj["screen_id"] = item.screen_id || null;
          // MainObj["sch_start_date"] = item.ss_start_date || null;
          // MainObj["sch_end_date"] = item.ss_end_date || null;
          MainObj["sch_is_active"] = self.scheduleObject.sch_is_active || "Y";
          MainObj["cinema_id"] = self.scheduleObject.cinema_id;

          // Single Screen data
          // MainObj["sch_start_date"] = item.sch_start_date || null;
          // MainObj["sch_end_date"] = item.sch_end_date || null;
          // MainObj["sch_is_active"] = item.sch_is_active || "Y";
          // schedule show according movie // Movie Mapping

          MainObj["scheduleshow"] = [];

          let moviePromises = item.movies.map(async (movie, movieIndex) => {
            MainObj["sch_start_date"] =
              moment(movie.ss_start_date).format("YYYY-MM-DD") || null;
            MainObj["sch_end_date"] =
              moment(movie.ss_end_date).format("YYYY-MM-DD") || null;

            let promises = dates.map(async (date, dateIndex) => {
              let MovieObj = {};
              MovieObj["cinema_id"] = self.scheduleObject.cinema_id;
              MovieObj["screen_id"] = item.screen_id;
              MovieObj["movie_details_id"] = movie.md_id;
              MovieObj["sch_artwork_url"] = movie.sch_artwork_url;
              MovieObj["ss_show_status"] = status_id;
              MovieObj["interval_time_in_mins"] = parseInt(
                this.selectedCinemaSettings.interval_time_in_mins
              );
              MovieObj["cleaning_time_in_mins"] = parseInt(
                this.selectedCinemaSettings.cleaning_time_in_mins
              );
              MovieObj["ads_time_in_mins"] = parseInt(
                this.selectedCinemaSettings.ads_time_in_mins
              );
              MovieObj["isNewSchedule"] = true;

              let totalMinutes = (movie.start * 10) / 30;
              let _totalMinutes = totalMinutes + movie.lengthMinutes;
              let _hours = Math.floor(_totalMinutes / 60);
              let hours = Math.floor(totalMinutes / 60);
              let minutes = totalMinutes % 60;
              let _minutes = _totalMinutes % 60;
              let ampm = "AM";
              let _ampm = "AM";
              // if (hours > 12) {
              //   ampm = "PM";
              //   hours = hours - 12;
              // }
              console.log("_hours :", _hours);
              console.log(
                "this.tConvert(`${_hours}:00`) :",
                self.tConvert(`${_hours - 12}:00`)
              );
              // if (_hours > 12) {
              //   _ampm = "PM";
              //   _hours = _hours - 12; // this.tConvert(`${_hours - 12}:00`).digit; //
              // }
              console.log("_hours :", _hours);
              // _hours = _hours >= 10 ? _hours : "0" + _hours;
              // hours = hours >= 10 ? hours : "0" + hours;
              minutes = minutes >= 10 ? minutes : "0" + minutes;
              _minutes = _minutes >= 10 ? _minutes : "0" + _minutes;
              // let showtime = hours + ":" + minutes + " " + ampm;
              // let endShowtime = _hours + ":" + _minutes + " " + _ampm;

              // let showtime = hours + ":" + minutes;
              let showtime = format24Hours(date, movie.start_time);
              let endShowtime = format24Hours(date, movie.end_time);
              MovieObj["ss_start_show_time"] = showtime;
              MovieObj["ss_end_show_time"] = endShowtime;

              MovieObj["ss_start_date"] = moment(date).format("YYYY-MM-DD"); // movie.ss_start_date;
              // movie.ss_end_date;
              console.log(
                "this.movieSelected.start_time :",
                self.movieSelected.start_time
              );
              console.log("date,movie.start_time :", date, movie.start_time);
              MovieObj["ss_start_date_time"] = +new Date(
                moment(date).format("YYYY-MM-DD") +
                  "T" +
                  showtime +
                  this.timeZone.tz_utc_offset
              );
              MovieObj["ss_is_active"] = movie.ss_is_active || "Y"; // movie.ss_end_date_time;
              //actual date
              if (
                moment(
                  moment().format("YYYY-MM-DD") +
                    " " +
                    self.CinemasSettings.cine_operation_start_time
                ).isSameOrAfter(
                  moment(
                    moment().format("YYYY-MM-DD") +
                      " " +
                      self.CinemasSettings.cine_operation_end_time
                  )
                )
              ) {
                if (
                  moment(
                    moment().format("YYYY-MM-DD") +
                      " " +
                      self.CinemasSettings.cine_operation_end_time
                  ).isAfter(
                    moment(
                      moment().format("YYYY-MM-DD") + " " + movie.start_time
                    )
                  )
                ) {
                  MovieObj["ss_actual_start_date"] = moment(date)
                    .add(1, "days")
                    .format("YYYY-MM-DD");
                  MovieObj["ss_actual_start_date_time"] = +new Date(
                    moment(date).add(1, "days").format("YYYY-MM-DD") +
                      "T" +
                      showtime +
                      this.timeZone.tz_utc_offset
                  );
                  MovieObj["ss_actual_end_date"] = moment(date)
                    .add(1, "days")
                    .format("YYYY-MM-DD");
                  MovieObj["ss_actual_end_date_time"] = +new Date(
                    moment(date).add(1, "days").format("YYYY-MM-DD") +
                      "T" +
                      endShowtime +
                      this.timeZone.tz_utc_offset
                  );
                  MovieObj["ss_end_date"] = moment(date)
                    .add(1, "days")
                    .format("YYYY-MM-DD");

                  MovieObj["ss_end_date_time"] = +new Date(
                    moment(date).add(1, "days").format("YYYY-MM-DD") +
                      "T" +
                      endShowtime +
                      this.timeZone.tz_utc_offset
                  );
                } else {
                  MovieObj["ss_actual_start_date"] =
                    moment(date).format("YYYY-MM-DD");
                  MovieObj["ss_actual_start_date_time"] = +new Date(
                    moment(date).format("YYYY-MM-DD") +
                      "T" +
                      showtime +
                      this.timeZone.tz_utc_offset
                  );
                  console.log("movie.start_time ABC:>> ", movie.start_time);
                  console.log("movie.end_time ABC:>> ", movie.end_time);
                  MovieObj["ss_actual_end_date"] =
                    movie.start_time.split(" ")[1] == "PM" &&
                    movie.end_time.split(" ")[1] == "AM"
                      ? moment(date).add(1, "days").format("YYYY-MM-DD")
                      : moment(date).format("YYYY-MM-DD");
                  MovieObj["ss_actual_end_date_time"] =
                    movie.start_time.split(" ")[1] == "PM" &&
                    movie.end_time.split(" ")[1] == "AM"
                      ? +new Date(
                          moment(date).add(1, "days").format("YYYY-MM-DD") +
                            "T" +
                            endShowtime +
                            this.timeZone.tz_utc_offset
                        )
                      : +new Date(
                          moment(date).format("YYYY-MM-DD") +
                            "T" +
                            endShowtime +
                            this.timeZone.tz_utc_offset
                        );
                  MovieObj["ss_end_date"] =
                    movie.start_time.split(" ")[1] == "PM" &&
                    movie.end_time.split(" ")[1] == "AM"
                      ? moment(date).add(1, "days").format("YYYY-MM-DD")
                      : moment(date).format("YYYY-MM-DD");

                  MovieObj["ss_end_date_time"] =
                    movie.start_time.split(" ")[1] == "PM" &&
                    movie.end_time.split(" ")[1] == "AM"
                      ? +new Date(
                          moment(date).add(1, "days").format("YYYY-MM-DD") +
                            "T" +
                            endShowtime +
                            this.timeZone.tz_utc_offset
                        )
                      : +new Date(
                          moment(date).format("YYYY-MM-DD") +
                            "T" +
                            endShowtime +
                            this.timeZone.tz_utc_offset
                        );
                }
                // if (
                //   moment(
                //     moment().format("YYYY-MM-DD") +
                //       " " +
                //       this.CinemasSettings.cine_operation_end_time
                //   ).isAfter(
                //     moment(
                //       moment().format("YYYY-MM-DD") +
                //         " " +
                //         movie.end_time
                //     )
                //   )
                // ) {
                //   // MovieObj["ss_end_actual_date"] = moment(date)
                //   //   .add(1, "days")
                //   //   .format("YYYY-MM-DD");
                //   // MovieObj["ss_actual_end_date_time"] = +new Date(
                //   //   moment(date)
                //   //     .add(1, "days")
                //   //     .format("YYYY-MM-DD") +
                //   //     " " +
                //   //     movie.end_time
                //   // );
                // } else {

                // }
              } else {
                MovieObj["ss_actual_end_date"] =
                  movie.start_time.split(" ")[1] == "PM" &&
                  movie.end_time.split(" ")[1] == "AM"
                    ? moment(date).add(1, "days").format("YYYY-MM-DD")
                    : moment(date).format("YYYY-MM-DD");
                MovieObj["ss_actual_start_date"] =
                  moment(date).format("YYYY-MM-DD");
                MovieObj["ss_actual_end_date_time"] =
                  movie.start_time.split(" ")[1] == "PM" &&
                  movie.end_time.split(" ")[1] == "AM"
                    ? +new Date(
                        moment(date).add(1, "days").format("YYYY-MM-DD") +
                          "T" +
                          endShowtime +
                          this.timeZone.tz_utc_offset
                      )
                    : +new Date(
                        moment(date).format("YYYY-MM-DD") +
                          "T" +
                          endShowtime +
                          this.timeZone.tz_utc_offset
                      );
                MovieObj["ss_actual_start_date_time"] = +new Date(
                  moment(date).format("YYYY-MM-DD") +
                    "T" +
                    showtime +
                    this.timeZone.tz_utc_offset
                );
                MovieObj["ss_end_date"] =
                  movie.start_time.split(" ")[1] == "PM" &&
                  movie.end_time.split(" ")[1] == "AM"
                    ? moment(date).add(1, "days").format("YYYY-MM-DD")
                    : moment(date).format("YYYY-MM-DD");

                MovieObj["ss_end_date_time"] =
                  movie.start_time.split(" ")[1] == "PM" &&
                  movie.end_time.split(" ")[1] == "AM"
                    ? +new Date(
                        moment(date).add(1, "days").format("YYYY-MM-DD") +
                          "T" +
                          endShowtime +
                          this.timeZone.tz_utc_offset
                      )
                    : +new Date(
                        moment(date).format("YYYY-MM-DD") +
                          "T" +
                          endShowtime +
                          this.timeZone.tz_utc_offset
                      );
              }

              //

              MovieObj["ss_start_date_time"] = +new Date(
                moment(date).format("YYYY-MM-DD") +
                  "T" +
                  showtime +
                  this.timeZone.tz_utc_offset
              );

              console.log(
                'moment(date).format("YYYY-MM-DD") + " " + endShowtime :',
                moment(date).format("YYYY-MM-DD") +
                  "T" +
                  showtime +
                  this.timeZone.tz_utc_offset
              );
              console.log(
                ' MovieObj["ss_start_date_time"]',
                MovieObj["ss_start_date_time"]
              );

              console.log("endShowtime :", endShowtime);
              console.log(
                'MovieObj["ss_end_date_time"]  :',
                MovieObj["ss_end_date_time"]
              );
              MovieObj["ss_is_active"] = movie.ss_is_active || "Y"; // movie.ss_end_date_time
              // array scheduleshowprice
              MovieObj["scheduleshowprice"] = [];
              let scheduleShowPricePromises = movie.scheduleShowPrice.map(
                (price, priceIndex) => {
                  let PriceObj = {};

                  dateCount = PriceObj["cinema_id"] =
                    this.scheduleObject.cinema_id;
                  PriceObj["screen_id"] = item.screen_id;
                  PriceObj["md_id"] = movie.md_id;
                  PriceObj["rate_card_id"] = price.rate_card_id;
                  PriceObj["rate_card_group_id"] = price.rc_g_id;
                  PriceObj["schedule_show_id"] = price.schedule_show_id;
                  PriceObj["screen_seat_type_id"] = price.screen_seat_type_id;
                  PriceObj["p_start_date_time"] =
                    this.movieSelected.ss_start_date; // price.p_start_date_time;
                  PriceObj["p_end_date_time"] = this.movieSelected.ss_end_date; // price.p_end_date_time;
                  PriceObj["p_is_active"] = price.p_is_active || "Y";

                  // Push Show Price
                  MovieObj["scheduleshowprice"].push(PriceObj);
                }
              );
              await Promise.all(scheduleShowPricePromises);

              // Push Show and Show Price
              MainObj["scheduleshow"].push(MovieObj);
            });
            await Promise.all(promises);
          });
          await Promise.all(moviePromises);
          // Final Array Push
          this.FinalArray.push(MainObj);
          console.log("this.FinalArray :", self.FinalArray);
        }
      );

      function format24Hours(date, time) {
        let newVal = date + " " + time;
        let finalVal = moment(newVal).format("HH:mm");
        return finalVal;
      }

      function toUnixTimeStamp(Datestring) {
        console.log("Datestring :", Datestring);
        return new Date(Datestring.toString()).getTime() / 1000;
      }
      // console.log("this.FinalArray :", this.FinalArray);

      this.btenable = true;
      await Promise.all(finalpromises)
        .then((result) => {
          let loader = this.$loading.show();

          // this.FinalArray[0].scheduleshow[0].cinema_id = 5
          console.log("this.FinalArray :", this.FinalArray);
          this.FinalArray.map((x) => {
            scheduleService
              .AddSchedule(x)
              .then((resp) => {
                this.btenable = false;
                loader.hide();
                const { data } = resp;
                if (data && data.status) {
                  this.$router.replace({
                    path: "view-schedule",
                  });
                  // this.$toasted.show(data.message);
                } else {
                  this.$toasted.show(data.message);
                }
              })
              .catch((err) => {
                this.$toasted.show(err);
              });
          });
        })
        .catch((err) => {
          this.$toasted.show(err);
        });
      // this.onFinalSubmit();
    },
    // onFinalSubmit: function() {
    //   this.submitted = true;
    //   this.$validator.validate().then(valid => {
    //     console.log("valid :", valid);
    //     if (valid) {
    //       this.submitSchedule()
    //         .then(() => {
    //           this.FinalArray.map(x => {
    //             let loader = this.$loading.show();

    //             scheduleService.AddSchedule(x)
    //               .then(resp => {
    //                 loader.hide();
    //                 const { data } = resp;
    //                 if (data && data.status) {
    //                   // this.$toasted.show(data.message);
    //                 } else {
    //                   this.$toasted.show(data.message);
    //                 }
    //               })
    //               .catch(err => {});
    //           });
    //         })
    //         .catch(error => {
    //           console.log("Reached Catch :", error);
    //         });
    //     }
    //   });
    // },
    getDateTime(date, time) {
      return moment(new Date(date))
        .tz(this.timeZone.tz_name)
        .format("DD-MM-YYYY");
    },
    // Cinema List
    getAllActiveCinemas: function (cine_id) {
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.CinemasList = data.Records;
            this.CinemasListCopy = data.Records;
            this.CinemasList.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                // this.selected.cinema = x.cine_name;
                let cinema = {
                  cine_name: x.cine_name,
                  cine_id: x.cine_id,
                };
                this.onSelectCinema(event, cinema);
              }
            });
          } else {
            // Show Error message
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          // Catch Error:
          this.$toasted.show(Error(error));
          console.log("Catch Error on getAllActiveCinemas :", error);
        });
    },
    getCinemaSetting: function (cinema_id) {
      scheduleService
        .GetCinemaSetting({ cinema_id })
        .then((response) => {
          const { data } = response;
          console.log("data.timeZone :", data.timeZone);
          if (data && data.status && data.Records.length > 0) {
            this.CinemasSettings = {
              ...this.CinemasSettings,
              ...data.Records[0],
            };
            this.movieSelected.interval_time_in_mins =
              data.Records[0].cine_interval_time_in_mins;
            this.selectedCinemaSettings.interval_time_in_mins =
              data.Records[0].cine_interval_time_in_mins;
            this.movieSelected.cleaning_time_in_mins =
              data.Records[0].cine_cleaning_time_in_mins;
            this.selectedCinemaSettings.cleaning_time_in_mins =
              data.Records[0].cine_cleaning_time_in_mins;
            this.movieSelected.ads_time_in_mins =
              data.Records[0].cine_setting_ads_time_in_mins;
            this.selectedCinemaSettings.ads_time_in_mins =
              data.Records[0].cine_setting_ads_time_in_mins;
            if (
              data.timeZone &&
              data.timeZone.tz_name &&
              data.timeZone.tz_name.length > 0
            ) {
              this.timeZone = {
                ...this.timeZone,
                ...data.timeZone,
              };
              this.getAllActiveMovies();
            } else {
              this.$toasted.show(
                "Please Add default Timezone in Cinema Settings"
              );
              this.$refs["test"].hide();
            }
            console.log("this.cinemaSettings :", this.CinemasSettings);
            console.log("this.cinemaSettings :", this.timeZone);

            // let startString = moment(
            //   moment().format("YYYY-MM-DD") +
            //     " " +
            //     this.CinemasSettings.cine_operation_start_time
            // ).format("YYYY-MM-DD h:mm A");

            // let endString = moment(
            //   moment().format("YYYY-MM-DD") +
            //     " " +
            //     this.CinemasSettings.cine_operation_end_time
            // ).format("YYYY-MM-DD h:mm A");
            let startString = "";
            if (
              this.CinemasSettings.cine_operation_start_time.split(" ")[1] ==
                "AM" ||
              this.CinemasSettings.cine_operation_start_time.split(" ")[1] ==
                "PM"
            ) {
              startString = moment(
                moment().format("YYYY-MM-DD") +
                  " " +
                  this.CinemasSettings.cine_operation_start_time
              ).format("YYYY-MM-DD h:mm A");
            } else {
              startString = moment(
                moment().format("YYYY-MM-DD") +
                  " " +
                  this.CinemasSettings.cine_operation_start_time
              ).format("YYYY-MM-DD H:mm");
            }

            let endString = "";
            if (
              this.CinemasSettings.cine_operation_end_time.split(" ")[1] ==
                "AM" ||
              this.CinemasSettings.cine_operation_end_time.split(" ")[1] == "PM"
            ) {
              endString = moment(
                moment().format("YYYY-MM-DD") +
                  " " +
                  this.CinemasSettings.cine_operation_end_time
              ).format("YYYY-MM-DD h:mm A");
            } else if (
              moment(
                moment().format("YYYY-MM-DD") +
                  " " +
                  this.CinemasSettings.cine_operation_start_time
              ).isAfter(
                moment(
                  moment().format("YYYY-MM-DD") +
                    " " +
                    this.CinemasSettings.cine_operation_end_time
                )
              )
            ) {
              endString = moment(
                moment().format("YYYY-MM-DD") +
                  " " +
                  this.CinemasSettings.cine_operation_end_time
              )
                .add(1, "d")
                .format("YYYY-MM-DD H:mm");
            } else if (
              this.CinemasSettings.cine_operation_end_time.split(":")[0] < 12
            ) {
              endString = moment(
                moment().format("YYYY-MM-DD") +
                  " " +
                  this.CinemasSettings.cine_operation_end_time
              )
                .add(1, "d")
                .format("YYYY-MM-DD H:mm");
            }
            // else if (
            //   this.CinemasSettings.cine_operation_end_time <=
            //   this.CinemasSettings.cine_operation_start_time
            // ) {
            //   endString = moment(
            //     moment().format("YYYY-MM-DD") +
            //       " " +
            //       this.CinemasSettings.cine_operation_end_time
            //   )
            //     .add(1, "d")
            //     .format("YYYY-MM-DD H:mm");
            // }
            else {
              endString = moment(
                moment().format("YYYY-MM-DD") +
                  " " +
                  this.CinemasSettings.cine_operation_end_time
              ).format("YYYY-MM-DD H:mm");
            }
            this.intervalsArray = intervals(startString, endString);
            function intervals(startString, endString) {
              var start = moment(startString, "YYYY-MM-DD hh:mm a");
              var end = moment(endString, "YYYY-MM-DD hh:mm a");

              // round starting minutes up to nearest 15 (12 --> 15, 17 --> 30)
              // note that 59 will round up to 60, and moment.js handles that correctly
              start.minutes(Math.ceil(start.minutes() / 15) * 15);

              var result = [];

              var current = moment(start);
              end = moment(end);
              end.add(4 * 60, "minutes");
              console.log("current :", current);
              while (current <= end) {
                result.push(current.format("HH:mm"));
                current.add(60, "minutes");
              }

              return result;
            }
          } else {
            this.$toasted.show("No Cinema Settings Found for selected cinema");
            this.$refs["test"].hide();
            // Show Message Here:
          }
        })
        .catch((error) => {
          // Catch Error:
          console.log("Catch Error on getCinemaSetting :", error);
        });
    },
    //
    getRatecardsList: function (cinema_id) {
      this.RatecardsList = [];
      this.RatecardsListCopy = [];
      scheduleService
        .GetRatecardGroupByCinemaId({ cinema_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.RatecardsList = data.Records;
            this.RatecardsListCopy = data.Records;
          } else {
            this.RatecardsList = [];
            this.RatecardsListCopy = [];
            // Show Message Here:
            this.$toasted.show("No Rate Cards Found for selected cinema");
            this.$refs["test"].hide();
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          // Catch Error:
          console.log("Catch Error on getCinemaSetting :", error);
        });
    },

    getRateCardGroupList: function (cinema_id) {
      scheduleService
        .GetRatecardGroupByCinemaId({ cinema_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.RatecardsList = data.Records;
            this.RatecardsListCopy = data.Records;
          } else {
            // Show Message Here:
            this.$toasted.show("No Rate Cards Found for selected cinema");
            this.$refs["test"].hide();
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          // Catch Error:
          console.log("Catch Error on getCinemaSetting :", error);
        });
    },

    concateMovieName(obj, separator) {
      Object.values(obj)
        .filter((val) => val)
        .join(separator);
    },
    onAsyncSearchMovies: _.debounce(function (query) {
      if (query) {
        this.searchValue = query;
        this.getAllActiveMovies();
      }
    }, 1 * 1000),
    getAllActiveMovies: function () {
      this.MoviesList = [];
      this.isSearchLoading = true;
      scheduleService
        .GetMovies({ schedule: this.searchValue })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.MovieListResult.length > 0) {
            this.MoviesList = data.MovieListResult.filter(
              (movie, movieIndex) => {
                if (movie.movie_is_active == "Y") {
                  movie.lengthMinutes =
                    movie.mrrdr_runtime +
                    this.CinemasSettings.cine_cleaning_time_in_mins +
                    this.CinemasSettings.cine_setting_ads_time_in_mins +
                    this.CinemasSettings.cine_interval_time_in_mins;
                  movie.length = (movie.lengthMinutes * 30) / 10;
                  movie.rateCard = [];
                  movie.scheduleShowPrice = [];
                  movie.md_id = movie.md_id;
                  movie.interval_time_in_mins =
                    this.CinemasSettings.cine_interval_time_in_mins;
                  movie.cleaning_time_in_mins =
                    this.CinemasSettings.cine_cleaning_time_in_mins;
                  movie.ads_time_in_mins =
                    this.CinemasSettings.cine_setting_ads_time_in_mins;
                  movie.movie_name =
                    movie.sound_format_name &&
                    String(movie.sound_format_name).length > 0
                      ? movie.movie_title +
                        (movie.mf_name ? " " + movie.mf_name + " -" : " -") +
                        [
                          movie.lang_iso_2,
                          movie.sub_lang_1_iso_2,
                          movie.sub_lang_2_iso_2,
                        ]
                          .filter(Boolean)
                          .join("/")
                          .toUpperCase() +
                        " (" +
                        movie.sound_format_name +
                        ")"
                      : movie.movie_title +
                        (movie.mf_name ? " " + movie.mf_name + " -" : " -") +
                        [
                          movie.lang_iso_2,
                          movie.sub_lang_1_iso_2,
                          movie.sub_lang_2_iso_2,
                        ]
                          .filter(Boolean)
                          .join("/")
                          .toUpperCase();
                  return movie;
                }
              }
            );
            this.showScheduleCard = true;
            // this.lists.movies = movieList;
          } else {
            // Show Message Here:
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          // Catch Error:
          console.log("Catch Error on getAllActiveMovies :", error);
        })
        .finally(() => {
          this.isSearchLoading = false;
        });
    },
    getAllActiveScreens: function (cinema_id) {
      console.log("cinema_id :", cinema_id);
      this.ScreenList = [];
      let payload = {
        cinema_id: cinema_id,
      };

      scheduleService
        .GetScreens(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            // this.lists.screens = data.Records;
            this.ScreenList = data.Records.filter(
              (x) => x.screen_seat_types.length > 0
            );
            this.ScreenListCopy = data.Records.filter(
              (x) => x.screen_seat_types.length > 0
            );
            this.ScreenList.map((x) => {
              this.selectedMoviesInScreens.push({
                ...x,
                movies: [],
              });
            });
          } else {
            // Show Message Here:
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          // Catch Error:
          this.$toasted.show(Error(error));
          console.log("Catch Error on getAllActiveScreens :", error);
        });
    },
    getSeatTypesListByScreenId: function (screen_id) {
      scheduleService
        .GetSeatTypesByScreenId({ screen_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
          } else {
            // Show Message Here:
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          // Catch Error:
          this.$toasted.show(Error(error));
          console.log("Catch Error on getSeatTypesListByScreenId :", error);
        });
    },
    onOpenAddPriceModal: function (
      screen,
      screenMovie,
      screenIndex,
      screenMovieIndex
    ) {
      this.movieSelected = screenMovie;
      this.selectedScreenSeatTypes = screen.screen_seat_types;
      this.screen_seat_card_mapping = screen.screen_seat_card_mapping;
      this.selectedMovieIndex = screenMovieIndex;
      this.selectedScreenIndex = screenIndex;

      this.$refs.ratecardmodal.show();
    },
    onDeleteMovie: function (
      screen,
      screenMovie,
      screenIndex,
      screenMovieIndex
    ) {
      this.selectedMoviesInScreens[screenIndex].movies.splice(
        screenMovieIndex,
        1
      );
    },
    onChangeRateCard: function (ratecard, seat, SeatTypeIndex) {
      // console.log("event, seat, SeatTypeIndex :", event, seat, SeatTypeIndex);
      // this.selectedRateCardObject.rate_card_id = event.target.value;
      console.log("ratecard :", ratecard);
      this.selectedRateCardObject.rate_card_id = ratecard.rc_id;
      this.selectedRateCardObject.rc_g_id = ratecard.rc_g_id;
      this.selectedRateCardObject.rate_card_name = ratecard.rc_g_name;
      this.selectedRateCardObject.screen_seat_type_id = seat.sst_id;

      this.selectedRateCardObject.SeatTypeIndex = SeatTypeIndex;
      this.movieSelected.scheduleShowPrice.map((x) => {
        x.searchRateCard = "";
      });
      this.RatecardsList = this.RatecardsListCopy;
      console.log(
        "this.selectedRateCardObject :>> ",
        this.selectedRateCardObject
      );

      // this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
      //   this.selectedMovieIndex
      // ].scheduleShowPrice[SeatTypeIndex]["rate_card_id"] = event.target.value;

      // this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
      //   this.selectedMovieIndex
      // ].scheduleShowPrice[SeatTypeIndex]["rate_card_name"] =
      //   ratecard.rate_card_name;

      // this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
      //   this.selectedMovieIndex
      // ].scheduleShowPrice[SeatTypeIndex].rate_card_id = event.target.value;
      // this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
      //   this.selectedMovieIndex
      // ].scheduleShowPrice[SeatTypeIndex].screen_seat_type_id = seat.sst_id;

      // let z =
      //   this.selectedScreenIndex.toString() +
      //   this.selectedMovieIndex.toString();
      // this.rateCard[z].screen_seat_type_id = seat.sst_id;
      // this.rateCard[z].rate_card_id = event.target.value;
      // this.rateCard[z] = {
      //   test: "test"
      // };
      // console.log("this.rateCard[z] :", this.rateCard[z]);
      let obj = this.movieSelected.scheduleShowPrice[SeatTypeIndex];

      let _Obj = {
        ...obj,
        rate_card_id: ratecard.rc_id,
        rc_g_id: ratecard.rc_g_id,
        searchRateCard: "",
        rate_card_name: ratecard.rc_g_name,
        screen_seat_type_id: seat.sst_id,
      };
      Vue.set(this.movieSelected.scheduleShowPrice, SeatTypeIndex, _Obj);
      this.$forceUpdate();
    },
    onClickupdateRateCard: function () {
      // this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
      //   this.selectedMovieIndex
      // ].scheduleShowPrice[this.selectedRateCardObject.SeatTypeIndex][
      //   "rate_card_id"
      // ] = this.selectedRateCardObject.rate_card_id;
      // this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
      //   this.selectedMovieIndex
      // ].scheduleShowPrice[this.selectedRateCardObject.SeatTypeIndex][
      //   "screen_seat_type_id"
      // ] = this.selectedRateCardObject.screen_seat_type_id;
      this.$refs.ratecardmodal.hide();
    },

    onSelectCinema: function (event, cinema) {
      this.selected.cinemaObject = cinema;
      this.selected.cinema = cinema.cine_name;
      this.scheduleObject.cinema_id = cinema.cine_id;
      this.getAllActiveScreens(cinema.cine_id);
      this.getCinemaSetting(cinema.cine_id);
      this.getRateCardGroupList(cinema.cine_id);
    },

    onSelectScreen: function (event, screen, screenIndex) {
      this.videoFormatError = false;
      this.soundFormatError = false;
      this.licenseDateError = false;

      if (screen.totalSeatLayout > 0) {
        // this.selectedMoviesInScreens[this.selectedScreenIndex]
        this.selectedScreen = screen;
        this.selected.screen_name = screen.screen_name;
        this.selectedScreenIndex = screenIndex;
        //newly added
        this.selectedScreenSeatTypes = this.selectedScreen.screen_seat_types;
        this.screen_seat_card_mapping =
          this.selectedScreen.screen_seat_card_mapping;
        let seat_type_length = this.selectedMoviesInScreens[
          this.selectedScreenIndex
        ].screen_seat_types
          ? this.selectedMoviesInScreens[this.selectedScreenIndex]
              .screen_seat_types.length
          : 0;
        if (seat_type_length > 0) {
          let scheduleShowPriceObj = {
            rate_card_id: null,
            searchRateCard: "",
            rate_card_name: "Select Rate Card Group",
            schedule_show_id: null,
            screen_seat_type_id: null,
            p_start_date_time: null,
            p_end_date_time: null,
            p_is_active: "Y",
          };
          let scheduleShowPriceArray = [];
          for (var i = 0; i < seat_type_length; i++) {
            scheduleShowPriceArray.push(scheduleShowPriceObj);
          }
          Object.assign(this.movieSelected, {
            scheduleShowPrice: scheduleShowPriceArray,
          });
          this.$forceUpdate();
        } else {
          this.$toasted.show("Screen Seat Type not found");
        }
      } else {
        this.$toasted.show(screen.screen_name + " has no seat layout");
      }
    },

    onSelectMovie: function (movie) {
      this.videoFormatError = false;
      this.soundFormatError = false;
      this.licenseDateError = false;

      let movieIndex = this.MoviesList.findIndex((x) => {
        return movie.md_id == x.md_id;
      });

      this.selectedMovie == movie;
      this.selectedMovieIndex = movieIndex + Math.floor(Math.random() * 10);
      this.movieSelected = {
        ...this.movieSelected,
        ...movie,
      };
      this.selectedScreenSeatTypes = this.selectedScreen.screen_seat_types;
      this.screen_seat_card_mapping =
        this.selectedScreen.screen_seat_card_mapping;

      let seat_type_length =
        this.selectedMoviesInScreens[this.selectedScreenIndex].screen_seat_types
          .length;

      let scheduleShowPriceObj = {
        rate_card_id: null,
        searchRateCard: "",
        rate_card_name: "Select Rate Card",
        schedule_show_id: null,
        screen_seat_type_id: null,
        p_start_date_time: null,
        p_end_date_time: null,
        p_is_active: "Y",
      };

      let scheduleShowPriceArray = [];

      for (var i = 0; i < seat_type_length; i++) {
        scheduleShowPriceArray.push(scheduleShowPriceObj);
      }
      if (String(this.selectedScreenIndex).length > 0) {
        Object.assign(this.movieSelected, {
          scheduleShowPrice: scheduleShowPriceArray,
        });
      }
      this.$forceUpdate();
    },
    selectCinema: function (cinema) {
      this.lists.cinemas.selectedCinema = cinema;
    },

    doSomethingInParentComponentFunction: function () {},
    changeCinema: function (params) {
      this.initialSelectedScreen = params;
    },
    // startDrag: function(screen, movie) {
    //   console.log("screen, movie :", screen, movie);
    //   // console.log(this.selectedMoviesInScreens[screen].movies[movie]);
    //   this.draggedObject.screen = screen;
    //   this.draggedObject.movie = movie;
    //   this.draggedObject.oldStart = this.selectedMoviesInScreens[screen].movies[
    //     movie
    //   ].start;
    //   this.draggedObject.length = this.selectedMoviesInScreens[screen].movies[
    //     movie
    //   ].length;
    //   this.draggedObject.md_thumbnail_url = this.selectedMoviesInScreens[
    //     screen
    //   ].movies[movie].md_thumbnail_url;
    //   this.draggedObject.lengthMinutes = this.selectedMoviesInScreens[
    //     screen
    //   ].movies[movie].lengthMinutes;

    //   //check if the drop is overlapping with something else
    //   //if no overlap,delete old object, else
    //   //add object to new place
    //   // this.selectedMoviesInScreens[screen].movies[movie].zIndex = 0;
    //   // console.log(this.selectedMoviesInScreens[screen].movies[movie]);
    // },
    endDrag: function (data) {
      // this.selectedMoviesInScreens[screen].movies[movie].zIndex = 99;

      console.log("drag start", data);
    },

    overLapIssue: function () {},
    dragEnter: function (screen, hour, minute) {
      this.dropLocation.screen = screen;
      this.dropLocation.hour = hour;
      this.dropLocation.minute = minute;
      // this.dropLocation.minute = minute;
    },
    openEditPopUp: function () {
      alert("popup");
    },
    handleDrop: function (data, event) {
      console.log("data :", data);

      // console.log("data, event :", data, event);
      //check if overlap with something else
      console.log("drop", this.dropLocation);
      let draggedMovie = data.movie;
      // console.log("this.draggedObject :", this.draggedObject);
      let doNotClone = 0;
      // let draggedMovie = this.selectedMoviesInScreens[this.draggedObject.screen]
      // .movies[this.draggedObject.movie];

      if (data.type == "presentMovie") {
        draggedMovie =
          this.selectedMoviesInScreens[this.draggedObject.screen].movies[
            this.draggedObject.movie
          ];

        this.draggedObject.newStart =
          (this.dropLocation.hour - 1) * 180 +
          (this.dropLocation.minute - 1) * 30;
        this.selectedMoviesInScreens[this.draggedObject.screen].movies[
          this.draggedObject.movie
        ].zIndex = 0;

        console.log("oldMovie :", draggedMovie);
        this.selectedMoviesInScreens[this.dropLocation.screen].movies.map(
          (otherMovie, index) => {
            //compare with start and start + length

            // draggedMoviestart > oldMovie start+length || draggedMoviestart +length < oldMovie start
            console.log("index, value :", index, otherMovie);
            console.log(
              "draggedMovie.start1 :",
              draggedMovie.start,
              draggedMovie.length,
              otherMovie.start,
              otherMovie.length,
              draggedMovie.start + draggedMovie.length,
              otherMovie.start + otherMovie.length
            );

            // if (
            //   this.draggedObject.newStart > otherMovie.start &&
            //   !(
            //     otherMovie.start + otherMovie.length <
            //     this.draggedObject.newStart
            //   )
            // ) {
            //   doNotClone = 1;
            //   alert("overlap1");
            // }
            if (
              this.draggedObject.newStart < otherMovie.start &&
              !(
                this.draggedObject.newStart + draggedMovie.length <
                otherMovie.start
              )
            ) {
              doNotClone = 1;
              alert("overlap old movie");
              if (
                this.dropLocation.screen == this.draggedObject.screen &&
                this.draggedObject.movie == index
              ) {
                doNotClone = 0;
              }
            }

            // if (
            //   draggedMovie.start >
            //     parseInt(otherMovie.start) + parseInt(otherMovie.length) ||
            //   parseInt(draggedMovie.start) + parseInt(draggedMovie.length) <
            //     otherMovie.start
            // ) {
            //   doNotClone = 1;
            //   alert("overlap");
            // }
          }
        );
      }

      if (data.type == "newMovie") {
        console.log(
          "dd",
          this.selectedMoviesInScreens[this.dropLocation.screen].movies
        );
        this.selectedMoviesInScreens[this.dropLocation.screen].movies.map(
          (otherMovie, index) => {
            let scheduleShowPriceObj = {
              rate_card_id: null,
              rate_card_name: "Select Rate Card",
              schedule_show_id: null,
              screen_seat_type_id: null,
              p_start_date_time: null,
              p_end_date_time: null,
              p_is_active: "Y",
            };
            otherMovie[0] = { scheduleShowPrice: scheduleShowPriceObj };
            let startCheck =
              (this.dropLocation.hour - 1) * 180 +
              (this.dropLocation.minute - 1) * 30;
            if (
              startCheck < otherMovie.start &&
              !(startCheck + draggedMovie.length < otherMovie.start)
            ) {
              doNotClone = 1;
              alert("overlap new movie");
            }
            // if (otherMovie.movie_details_id == data.movie.md_id) {
            //   let scheduleShowPriceObj = {
            //     rate_card_id: 1,
            //     schedule_show_id: "1",
            //     screen_seat_type_id: "18",
            //     p_start_date_time: 1,
            //     p_end_date_time: 1,
            //     p_is_active: "Y"
            //   };
            //   otherMovie.push({ scheduleShowPrice: scheduleShowPriceObj });
            // }
          }
        );
      }

      //create new movie
      if (doNotClone == 0) {
        this.selectedMoviesInScreens[this.dropLocation.screen].movies =
          this.selectedMoviesInScreens[this.dropLocation.screen].movies.filter(
            (movie, index) => {
              console.log("lastCheck", movie);
              // if (movie.zIndex == 99) return movie;
              return movie.zIndex == 99;
            }
          );
        // let dropScreen;
        // if(data.type == "presentMovie"){
        //   dropScreen = this.draggedObject.screen;
        // }else if (data.type == "newMovie"){
        //   dropScreen = this.dropLocation.screen;
        // }
        // if(this.selectedMoviesInScreens[this.dropLocation.screen].movies.filter((movie,movieIndex)=>{

        // }))

        this.selectedMoviesInScreens[this.dropLocation.screen].movies.push({
          length: draggedMovie.length,
          lengthMinutes: draggedMovie.lengthMinutes,
          movie_details_id: draggedMovie.md_id,
          md_id: draggedMovie.md_id,
          start:
            (this.dropLocation.hour - 1) * 180 +
            (this.dropLocation.minute - 1) * 30,
          zIndex: 99,
          mf_name: draggedMovie.mf_name,
          md_thumbnail_url: draggedMovie.md_thumbnail_url,
          lang_name: draggedMovie.lang_name,
          movie_title: draggedMovie.movie_title,
        });

        let seat_type_length =
          this.selectedMoviesInScreens[this.dropLocation.screen]
            .screen_seat_types.length;

        this.selectedMoviesInScreens[this.dropLocation.screen].movies.map(
          (x, movieIndex) => {
            let scheduleShowPriceObj = {
              rate_card_id: null,
              rate_card_name: "Select Rate Card",
              schedule_show_id: null,
              screen_seat_type_id: null,
              p_start_date_time: null,
              p_end_date_time: null,
              p_is_active: "Y",
            };
            let scheduleShowPriceArray = [];
            console.log(
              'x.hasOwnProperty("scheduleShowPrice") :',
              x.hasOwnProperty("scheduleShowPrice")
            );
            console.log("x.scheduleShowPrice :", x.scheduleShowPrice);
            if (
              x.hasOwnProperty("scheduleShowPrice") &&
              x.scheduleShowPrice.length > 0
            ) {
              console.log("x.scheduleShowPrice :", x.scheduleShowPrice);
              scheduleShowPriceArray = x.scheduleShowPrice;
            } else {
              console.log("seat_type_length :", seat_type_length);
              // let z =
              //   this.dropLocation.screen.toString() + movieIndex.toString();
              // this.rateCard[z] = [];
              for (var i = 0; i < seat_type_length; i++) {
                scheduleShowPriceArray.push(scheduleShowPriceObj);

                //   this.rateCard[z].push(scheduleShowPriceObj);
              }
            }
            Object.assign(x, { scheduleShowPrice: scheduleShowPriceArray });
            //  x = { ...x,{scheduleShowPrice: scheduleShowPriceObj} };
          }
        );
      }
      if (doNotClone == 1 && data.type != "newMovie") {
        this.selectedMoviesInScreens[this.draggedObject.screen].movies.push({
          length: draggedMovie.length,
          lengthMinutes: draggedMovie.lengthMinutes,
          movie_details_id: draggedMovie.md_id,
          md_id: draggedMovie.md_id,
          start: draggedMovie.start,
          zIndex: 99,
          md_thumbnail_url: draggedMovie.md_thumbnail_url,
          mf_name: draggedMovie.mf_name,
          lang_name: draggedMovie.lang_name,
          movie_title: draggedMovie.movie_title,
        });
        let seat_type_length =
          this.selectedMoviesInScreens[this.dropLocation.screen]
            .screen_seat_types.length;
        this.selectedMoviesInScreens[this.dropLocation.screen].movies.map(
          (x, movieIndex) => {
            let scheduleShowPriceObj = {
              rate_card_id: null,
              rate_card_name: "Select Rate Card",
              schedule_show_id: null,
              screen_seat_type_id: null,
              p_start_date_time: null,
              p_end_date_time: null,
              p_is_active: "Y",
            };
            let scheduleShowPriceArray = [];
            if (
              x.hasOwnProperty("scheduleShowPrice") &&
              x.scheduleShowPrice.length > 0
            ) {
              scheduleShowPriceArray = x.scheduleShowPrice;
            } else {
              let z =
                this.dropLocation.screen.toString() + movieIndex.toString();
              this.rateCard[z] = [];
              for (var i = 0; i < seat_type_length; i++) {
                scheduleShowPriceArray.push(scheduleShowPriceObj);

                this.rateCard[z].push(scheduleShowPriceObj);
              }
            }
            Object.assign(x, { scheduleShowPrice: scheduleShowPriceArray });
            //  x = { ...x,{scheduleShowPrice: scheduleShowPriceObj} };
          }
        );
      }

      // alert(`You dropped with data: ${JSON.stringify(data)}`);
    },
    closeModalSection: function () {},
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/ScheduleComponents/schedule2.vue